<template>
  <div>
    <v-dialog v-model="bookingDialog" max-width="1300" scrollable persistent
      :disabled="isCreateBooking || isLoading || isMainLoading">
      <v-card outlined>
        <v-overlay absolute v-if="isLoading" opacity="0.7" color="white">
          <v-progress-circular indeterminate color="green" size="70"></v-progress-circular>
        </v-overlay>
        <v-overlay absolute v-if="isLoadReBooking" opacity="0.7" class="text-center">
          <div>
            <v-progress-circular
              :rotate="-90"
              :size="150"
              :width="18"
              :value="loadReBookingProgress"
              color="white"
            >
              <span style="font-size: 30px;">{{ loadReBookingProgress }}%</span>
            </v-progress-circular>
          </div>
          <div class="mt-3" style="font-size: 22px;">{{ $t('validate.checking_empty_stall') }}</div>
        </v-overlay>
        <v-card-title
          :class="`d-flex justify-space-between align-center white--text`"
          :style="`background-color: ${currentType.isMonthly ? 'var(--monthly-booking-base)' : currentType.isDaily ? 'var(--daily-booking-base)' : ''}`"
        >
          <div v-if="booking && booking.status != 'cancelled'">
            {{ isEdit ? $t('action_type.edit') : '' }}{{ $t('booking.booking_stall') }}
          </div>
          <div v-else-if="booking && booking.status == 'cancelled'">{{ $t('booking.booking_being') }}<v-chip color="error">{{ $t('cancel') }}</v-chip></div>
          <div v-else-if="!booking">{{ $t('booking.booking_stall') }}</div>
          <v-btn color="white" icon @click="bookingDialog = false"><v-icon>mdi-close</v-icon></v-btn>
        </v-card-title>

        <v-card-text v-if="!booking || (booking && isEdit)" class="px-8">
          <v-stepper
            v-model="step"
            non-linear 
            elevation="15" 
            class="mt-6"
            style="z-index: 1;"
          >
            <v-stepper-header style="height: 140px;" :class="`${currentType.isMonthly ? 'step-monthly' : 'step-daily'}`">
              <v-stepper-step
                :editable="isEdit"
                step="1"
              >
                <h3 :class="`mb-1 ${typeColor.textClass}`">{{ $t('area.step_1') }}</h3>
                <span :class="`${typeColor.textClass}`">{{ $t('customer.customer_detail') }}</span>
              </v-stepper-step>
              <v-divider></v-divider>
              <v-stepper-step
                :editable="isEdit"
                step="2"
              >
                <h3 :class="`mb-1 ${typeColor.textClass}`">{{ $t('area.step_2') }}</h3>
                <span :class="`${typeColor.textClass}`">{{ $t('area.select_date_and_empty_stall') }}</span>
              </v-stepper-step>
              <v-divider></v-divider>
              <v-stepper-step
                :editable="isEdit"
                step="3"
              >
                <h3 :class="`mb-1 ${typeColor.textClass}`">{{ $t('area.step_3') }}</h3>
                <span :class="`${typeColor.textClass}`">{{ $t('area.stall_detail') }}</span>
              </v-stepper-step>
              <v-divider></v-divider>
              <v-stepper-step
                :editable="isEdit"
                step="4"
              >
                <h3 :class="`mb-1 ${typeColor.textClass}`">{{ $t('area.step_4') }}</h3>
                <span :class="`${typeColor.textClass}`">{{ isEdit || currentType.isMonthly ? $t('summary') : $t('payment_summary') }}</span>
              </v-stepper-step>
            </v-stepper-header>

          </v-stepper>
          <hr class="mt-10" />
          <v-stepper 
            v-model="step" 
            non-linear
            elevation="0" 
            style="overflow: visible;"
          >
            <v-stepper-items style="overflow: visible;">
              <v-stepper-content step="1" class="px-2">
                <v-form ref="formStep1">
                  <h3 :class="`${typeColor.textClass}`"><b>{{ $t('customer.customer_information') }}</b></h3>
                  <v-row class="mt-3">
                    <v-col cols="4" style="min-height: 200px;">
                      <CustomerCard2
                        style="height: 100%;"
                        :customer="form.customer"
                        :projectId="projectId"
                        :marketId="marketId"
                        :color="typeColor.color"
                        @onSelectCustomer="selectCustomer"
                      />
                    </v-col>
                    <v-col cols="8">
                      <v-row>
                        <v-col cols="6">
                          <SelectCustomerInput
                            v-if="!isEdit"
                            v-model="form.customer"
                            outlined
                            prepend-inner-icon="mdi-account"
                            :label="$t('customer.search_customer')"
                            :placeholder="$t('customer.search_customer')"
                            :hint="$t('account.search_customer_hint')"
                            :persistent-hint="true"
                            @onSelect="selectCustomer"
                            :color="typeColor.color"
                            :rules="[rules.required]"
                          />
                          <v-text-field
                            v-else
                            :value="form.customer.labelSearch"
                            outlined
                            prepend-inner-icon="mdi-account"
                            :label="$t('market.marchant_name')"
                            :placeholder="$t('market.marchant_name')"
                            :color="typeColor.color"
                            disabled
                          />
                        </v-col>
                        <v-col cols="6">
                          <v-autocomplete 
                            v-model="form.bookingChannel" 
                            :items="[...getBookingChannelNameOnly, { isAdd: true }]"
                            :label="$t('booking.select_booking_channel')"
                            :placeholder="$t('booking.select_booking_channel')"
                            item-text="name" 
                            item-value="form"
                            outlined
                            return-object
                            prepend-inner-icon="mdi-tablet-cellphone"
                            ref="bookingChannel"
                            :color="typeColor.color"
                            :menu-props="{ closeOnContentClick: true }"
                          >
                            <template v-slot:item="{ item, attrs, on, parent }">
                              <v-list-item v-if="!item.isAdd" v-bind="attrs" v-on="on">
                                <v-list-item-content>
                                  <v-list-item-title v-text="item.name"></v-list-item-title>
                                </v-list-item-content>
                              </v-list-item>
                              <v-list-item v-else>
                                <v-btn color="success" @click="isChannel = true;" block elevation="0">{{ $t('booking.add_booking_channel') }}</v-btn>
                              </v-list-item>
                            </template>
                            <template v-slot:no-data>
                              <v-list-item>
                                <v-btn color="success" @click="isChannel = true;" block elevation="0">{{ $t('booking.add_booking_channel') }}</v-btn>
                              </v-list-item>
                            </template>
                          </v-autocomplete>
                        </v-col>
                        <v-col cols="12" v-if="form.customer && !isEdit">
                          <div>
                            <div style="font-size: 20px; font-weight: bold; margin-bottom: 10px;">{{ $t('booking.customer_booking_history') }}</div>
                            <LatestBookings 
                              :bookings="latestBookings" 
                              :isLoading="isLoadLatestBooking" 
                              :isMonthly="currentType.isMonthly"
                              @clickLatestBooking="clickLatestBooking"
                            />
                          </div>
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>
                  <div class="mt-8 px-5 py-3" 
                    :style="`border: 3px solid ${ currentType.isMonthly ? 'var(--monthly-booking-base)' : 'var(--daily-booking-base)'}; border-radius: 10px;`"
                  >
                    <h3 :class="`${typeColor.textClass}`"><b>{{ $t('area.market_detail') }}</b></h3>
                    <div class="d-flex mt-3">
                      <div :style="isEdit ? 'width: 100%;' : 'width: 45%;'" class="pe-2">
                        <v-text-field 
                          v-model="form.businessName"
                          :label="$t('contract.business_name')" 
                          :placeholder="$t('contract.business_name')"
                          outlined
                          prepend-inner-icon="mdi-store-outline"
                          :color="typeColor.color"
                          :rules="[rules.required]"
                          style="transform: scaleY(0.87) !important;"
                        />
                      </div>
                      <div style="width: 55%;" class="ps-2" v-if="!isEdit">
                        <SelectProductInput
                          v-model="form.products"
                          :projectId="projectId"
                          :marketId="marketId"
                          :products="getProducts"
                          :label="$t('product.title')"
                          outlined
                          prepend-inner-icon="mdi-basket-outline"
                          appendActionType="button"
                          :color="typeColor.color"
                          :chipColor="typeColor.color"
                          style="transform: scaleY(0.87) !important;"
                        >
                          <template v-slot:append-outer>
                            <v-btn
                              style="height: 56px;"
                            >
                              <v-icon>mdi-plus</v-icon>
                            </v-btn>
                          </template>
                        </SelectProductInput>
                      </div>
                    </div>
                  </div>
                </v-form>
              </v-stepper-content>

              <v-stepper-content step="2" class="px-2 pt-4">
                <v-form ref="formStep2">
                  <div class="d-flex align-center justify-space-between">
                    <div class="d-flex align-center" style="height: 54px;">
                      <h3><b>{{ $t('booking.booking_type') }}</b></h3>
                      <v-radio-group
                        v-model="form.subType"
                        row
                        hide-details
                        class="mt-0 ms-3"
                        @change="changeSubType"
                        :disabled="isEdit ? true : false"
                      >
                        <v-radio
                          :label="$t('monthly')"
                          value="monthly"
                          :color="typeColor.color"
                        ></v-radio>
                        <v-radio
                          :label="$t('daily')"
                          value="daily"
                          :color="typeColor.color"
                        ></v-radio>
                        <v-radio
                          :label="$t('daily_repeat')"
                          value="daily-repeat"
                          :color="typeColor.color"
                        ></v-radio>
                      </v-radio-group>
                    </div>
                  </div>

                  <template v-if="form.subType == 'daily'">
                    <v-row class="mt-2">
                      <v-col cols="3">
                        <v-menu ref="menu_start_date_all" v-model="form.isStartDate" :close-on-content-click="false"
                          :return-value.sync="form.startDate" transition="scale-transition" offset-y min-width="auto"
                          :disabled="isLoadSearch">
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field :value="$helper.datelabel(form.startDate)" :label="$t('area.enter_stall_date')"
                              prepend-inner-icon="mdi-calendar" readonly outlined v-bind="attrs" v-on="on"
                              :disabled="isLoadSearch || isEdit" :color="typeColor.color"></v-text-field>
                          </template>
                          <v-date-picker v-model="form.startDate" no-title scrollable locale="th"
                            :header-date-format="$helper.headerDateFormat" :year-format="$helper.yearFormat"
                            :min="$moment().format('YYYY-MM-DD')" persistent-hint :disabled="isLoadSearch"
                            :weekday-format="$helper.formatWeekday" :month-format="$helper.formatMonth">
                            <v-spacer></v-spacer>
                            <v-btn text color="error" @click="form.isStartDate = false"
                              :disabled="isLoadSearch">{{ $t('cancel') }}</v-btn>
                            <v-btn text color="success" :disabled="isLoadSearch"
                              @click="$refs.menu_start_date_all.save(form.startDate);">{{ $t('confirm') }}</v-btn>
                          </v-date-picker>
                        </v-menu>
                      </v-col>
                      <v-col cols="2">
                        <v-select class="text-center" prepend-inner-icon="mdi-clock-outline" :label="$t('time')" outlined :no-data-text="$t('noinfo')"
                          v-model="form.startTime" :items="$helper.timeLabel().hoursMinutes" :disabled="isLoadSearch || isEdit" :color="typeColor.color"></v-select>
                      </v-col>
                      <v-col cols="1" class="text-center align-center mt-3 text-lg">{{ $t('to') }}</v-col>
                      <v-col cols="3">
                        <v-menu ref="menu_end_date_all" v-model="form.isEndDate" :close-on-content-click="false"
                          :return-value.sync="form.endDate" transition="scale-transition" offset-y min-width="auto"
                          :disabled="isLoadSearch">
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field :value="$helper.datelabel(form.endDate)" :label="$t('area.exit_stall_date')"
                              prepend-inner-icon="mdi-calendar" readonly outlined v-bind="attrs" v-on="on"
                              :disabled="isLoadSearch || isEdit" :color="typeColor.color"></v-text-field>
                          </template>
                          <v-date-picker v-model="form.endDate" no-title scrollable locale="th"
                            :header-date-format="$helper.headerDateFormat" :year-format="$helper.yearFormat"
                            :min="form.startDate" persistent-hint :disabled="isLoadSearch"
                            :weekday-format="$helper.formatWeekday" :month-format="$helper.formatMonth">
                            <v-spacer></v-spacer>
                            <v-btn text color="error" @click="form.isEndDate = false"
                              :disabled="isLoadSearch">{{ $t('cancel') }}</v-btn>
                            <v-btn text color="success" :disabled="isLoadSearch"
                              @click="$refs.menu_end_date_all.save(form.endDate);">{{ $t('confirm') }}</v-btn>
                          </v-date-picker>
                        </v-menu>
                      </v-col>
                      <v-col cols="2">
                        <v-select class="text-center" prepend-inner-icon="mdi-clock-outline" :label="$t('time')" outlined :no-data-text="$t('noinfo')"
                          v-model="form.endTime" :items="$helper.timeLabel().hoursMinutes" :disabled="isLoadSearch || isEdit"></v-select>
                      </v-col>
                      <v-col cols="1" class="text-center align-center mt-3 ps-0 py-0">
                        <v-btn class="px-0" style="height: 56px;" block large :color="typeColor.color" @click="searchAllAvailableAreas()" :disabled="isLoadSearch || isEdit">
                          <v-icon left>mdi-magnify</v-icon>
                          {{ $t('search') }}
                        </v-btn>
                      </v-col>
                    </v-row>

                    <template v-if="!isEdit">
                      <h3 :class="`${typeColor.textClass}`"><b>{{ $t('area.all_empty_stall', { count: allAvailableAreas.length }) }}</b></h3>
                      <div class="d-flex flex-wrap justify-space-between align-center">
                        <div style="font-size: 20px;" class="grey--text">
                          {{ $t('date') }} {{ $moment(form.tempStartDate).format('D MMMM YYYY') }} {{ $t('time') }} {{ form.tempStartTime }} - 
                          {{ $t('date') }} {{ $moment(form.tempEndDate).format('D MMMM YYYY') }} {{ $t('time') }} {{ form.tempEndTime }}
                        </div>
                        <div>
                          <v-btn text :color="typeColor.color" @click="searchAllAvailableAreas()" :disabled="isLoadSearch">
                            <v-icon left>mdi-refresh</v-icon>
                            {{ $t('area.search_empty_stall_repeat') }}
                          </v-btn>
                        </div>
                      </div>
                    </template>
                  </template>
  
                  <template v-if="form.subType == 'monthly'">
                    <div class="flex flex-wrap align-top mt-4">
                      <div class="me-3" style="width: 200px;">
                        <v-select
                          v-model="form.stallType"
                          :placeholder="$t('area.stall_type')" 
                          :label="$t('area.stall_type')"
                          :items="[
                            { text: $t('contact.stall_type.regularly'), value: 'regularly' },
                            { text: $t('contact.stall_type.temporary'), value: 'temporary' },
                          ]"  
                          item-text="text"
                          item-value="value"
                          outlined
                          :disabled="isLoadSearch"
                          :rules="[rules.required]"
                          :no-data-text="$t('noinfo')"
                        />
                      </div>
                      <div class="flex-1">
                        <v-menu ref="menu_start_date_all_m" v-model="form.isStartDate" :close-on-content-click="false"
                          :return-value.sync="form.startDate" transition="scale-transition" offset-y min-width="auto"
                          :disabled="isLoadSearch">
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field :value="$helper.datelabel(form.startDate)" :label="$t('contract.start_date')"
                              prepend-inner-icon="mdi-calendar" readonly outlined v-bind="attrs" v-on="on"
                              :disabled="isLoadSearch" :color="typeColor.color"></v-text-field>
                          </template>
                          <v-date-picker v-model="form.startDate" no-title scrollable locale="th"
                            :header-date-format="$helper.headerDateFormat" :year-format="$helper.yearFormat"
                            persistent-hint :disabled="isLoadSearch"
                            :weekday-format="$helper.formatWeekday" :month-format="$helper.formatMonth">
                            <v-spacer></v-spacer>
                            <v-btn text color="error" @click="form.isStartDate = false"
                              :disabled="isLoadSearch">{{ $t('cancel') }}</v-btn>
                            <v-btn text color="success" :disabled="isLoadSearch"
                              @click="$refs.menu_start_date_all_m.save(form.startDate); calContractDays(); isEdit ? searchAllAvailableAreas() : null">{{ $t('confirm') }}</v-btn>
                          </v-date-picker>
                        </v-menu>
                      </div>
                      <div class="mx-5 mt-4">{{ $t('to') }}</div>
                      <div class="flex-1">
                        <v-menu ref="menu_end_date_all_m" v-model="form.isEndDate" :close-on-content-click="false"
                          :return-value.sync="form.endDate" transition="scale-transition" offset-y min-width="auto"
                          :disabled="isLoadSearch">
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field :value="$helper.datelabel(form.endDate)" :label="$t('contract.end_date')"
                              prepend-inner-icon="mdi-calendar" readonly outlined v-bind="attrs" v-on="on"
                              :disabled="isLoadSearch" :color="typeColor.color"></v-text-field>
                          </template>
                          <v-date-picker v-model="form.endDate" no-title scrollable locale="th"
                            :header-date-format="$helper.headerDateFormat" :year-format="$helper.yearFormat"
                            :min="form.startDate" persistent-hint :disabled="isLoadSearch"
                            :weekday-format="$helper.formatWeekday" :month-format="$helper.formatMonth">
                            <v-spacer></v-spacer>
                            <v-btn text color="error" @click="form.isEndDate = false"
                              :disabled="isLoadSearch">{{ $t('cancel') }}</v-btn>
                            <v-btn text color="success" :disabled="isLoadSearch"
                              @click="$refs.menu_end_date_all_m.save(form.endDate); calContractDays(); isEdit ? searchAllAvailableAreas() : null">{{ $t('confirm') }}</v-btn>
                          </v-date-picker>
                        </v-menu>
                      </div>
                      <div class="ms-3" style="width: 150px;">
                        <v-text-field :label="$t('contract.contract_duration_days')"
                          :messages="dayMonthYearText(form.startDate, form.endDate)" v-model="form.contractDays"
                          @change="editContractDays($event, index); isEdit ? searchAllAvailableAreas() : null" outlined :disabled="isLoadSearch" :color="typeColor.color"></v-text-field>
                      </div>
                      <div v-if="!isEdit" class="ms-3 d-flex align-top" style="width: 100px;">
                        <v-btn class="px-0" style="height: 56px;" block large :color="typeColor.color" @click="searchAllAvailableAreas()" :disabled="isLoadSearch || isEdit">
                          <v-icon left>mdi-magnify</v-icon>
                          {{ $t('search') }}
                        </v-btn>
                      </div>
                    </div>

                    <template v-if="!isEdit">
                      <h3 :class="`${typeColor.textClass}`"><b>{{ $t('area.all_empty_stall', { count: allAvailableAreas.length }) }}</b></h3>
                      <div class="d-flex flex-wrap justify-space-between align-center">
                        <div style="font-size: 20px;" class="grey--text">
                          {{ $t('date') }} {{ $moment(form.tempStartDate).format('D MMMM YYYY') }} {{ $t('to') }} 
                          {{ $t('date') }} {{ $moment(form.tempEndDate).format('D MMMM YYYY') }}
                        </div>
                        <div>
                          <v-btn text :color="typeColor.color" @click="searchAllAvailableAreas()" :disabled="isLoadSearch">
                            <v-icon left>mdi-refresh</v-icon>
                            {{ $t('area.search_empty_stall_repeat') }}
                          </v-btn>
                        </div>
                      </div>
                    </template>
                  </template>

                  <template v-if="form.subType == 'daily-repeat'">
                    <SelectLoopDate
                      ref="selectLoopDate"
                      type="booking-daily"
                      :startDate.sync="form.startDate"
                      :endDate.sync="form.endDate"
                      :startTime.sync="form.startTime"
                      :endTime.sync="form.endTime"
                      :loopType.sync="form.loopType"
                      :loopDays.sync="form.loopDays"
                      :loopDate.sync="form.loopDate"
                      :loopWeekDays.sync="form.loopWeekDays"
                      :loopData.sync="loopData"
                      :isHideTextSummary="true"
                      :disabled="isEdit"
                      class="mb-12"
                    />
                    <div v-if="!isEdit">
                      <h3 :class="`${typeColor.textClass}`"><b>{{ $t('area.all_empty_stall', { count: allAvailableAreas.length }) }}</b></h3>
                      <div class="d-flex flex-wrap justify-space-between align-center">
                        <div style="font-size: 20px;" class="grey--text">
                          {{ $t('date') }} {{ $moment(form.startDate).format('D MMMM YYYY') }} {{ $t('time') }} {{ form.startTime }} {{ $t('to') }} 
                          {{ $t('date') }} {{ $moment(form.endDate).format('D MMMM YYYY') }} {{ $t('time') }} {{ form.endTime }} <b> {{ $t('total') }} {{ loopData.all.length }} {{ $t('day') }}</b>
                        </div>
                        <div>
                          <v-btn text :color="typeColor.color" @click="searchAllAvailableAreas()" :disabled="isLoadSearch">
                            <v-icon left>mdi-refresh</v-icon>
                            {{ $t('area.search_empty_stall_repeat') }}
                          </v-btn>
                        </div>
                      </div>
                    </div>
                  </template>
                  <template v-if="!isEdit">
                    <div class="d-flex flex-wrap justify-space-between align-center mt-4">
                      <div>
                        <v-text-field
                          v-if="viewType == 'plan'"
                          v-model="searchArea"
                          prepend-inner-icon="mdi-magnify"
                          :placeholder="$t('area.search_stall')"
                          hide-details
                          outlined
                          dense
                          style="max-width: 300px"
                        />
                        <v-chip-group 
                          v-model="filterArea"
                          @change="changeFilterAreas($event, 'All')"
                          v-if="viewType == 'table'"
                        >
                          <v-chip :color="filterArea == 'All' ? typeColor.color : ''"  class="mb-2 mr-2" value="All">{{ $t('all') }}</v-chip>
                          <v-chip color="success" :outlined="filterArea != 'isAvailable'" class="mb-2 mr-2" value="isAvailable">{{ $t('area.empty_stall') }}</v-chip>
                          <v-chip color="warning" :outlined="filterArea != 'isSuspend'" class="mb-2 mr-2" value="isSuspend">{{ $t('area.parking_area') }}</v-chip>
                          <v-chip color="info" :outlined="filterArea != 'isOutContract'" class="mb-2 mr-2" value="isOutContract">{{ $t('contract.not_available_stall_out_of_contract') }}</v-chip>
                          <v-chip v-if="form.subType != 'daily'" color="error" :outlined="filterArea != 'isInContract'" class="mb-2 " value="isInContract">{{ $t('contract.not_available_stall_in_contract') }}</v-chip>
                        </v-chip-group>
                      </div>
                      <div>
                        <SelectViewType
                          v-model="viewType"
                          :color="typeColor.color"
                        />
                      </div>
                    </div>
                    <div class="mt-4">
                      <v-text-field
                        v-if="viewType == 'table'"
                        v-model="searchArea"
                        prepend-inner-icon="mdi-magnify"
                        :placeholder="$t('area.search_stall')"
                        hide-details
                        outlined
                        dense
                        style="max-width: 300px"
                      />
                    </div>
                  </template>

                  <template v-if="isEdit">
                    <template v-if="currentType.isMonthly">
                      <h3 :class="`${typeColor.textClass}`"><b>{{ $t('area.all_stall_count', { count: formAreaBookings.length }) }}</b></h3>
                      <div class="d-flex flex-wrap justify-space-between align-center mb-4">
                        <div style="font-size: 20px;" class="grey--text">
                          {{ $t('date') }} {{ $moment(form.startDate).format('D MMMM YYYY') }} {{ $t('to') }} 
                          {{ $t('date') }} {{ $moment(form.endDate).format('D MMMM YYYY') }}
                        </div>
                      </div>
                    </template>
                    <template v-if="currentType.isDaily">
                      <h3 :class="`${typeColor.textClass}`"><b>{{ $t('area.all_stall_count', { count: formAreaBookings.length }) }}</b></h3>
                      <div class="d-flex flex-wrap justify-space-between align-center mb-4">
                        <div style="font-size: 20px;" class="grey--text">
                          {{ $t('date') }} {{ $moment(form.startDate).format('D MMMM YYYY') }} {{ $t('time') }} {{ form.startTime }} {{ $t('to') }} 
                          {{ $t('date') }} {{ $moment(form.endDate).format('D MMMM YYYY') }} {{ $t('time') }} {{ form.endTime }}
                        </div>
                      </div>
                    </template>
                  </template>

                  <div v-if="isLoadSearch" class="d-flex align-center justify-center py-10">
                    <v-progress-circular indeterminate color="green" size="40"></v-progress-circular>
                  </div>
                  <template v-else>
                    <div v-if="viewType == 'table'" class="border mt-7">
                      <v-data-table
                        v-model="form.selectedAreas"
                        :headers="areaTable.headers"
                        :items="currentVacancyAreas"
                        :items-per-page="10"
                        :loading="isLoadSearch" 
                        item-key="objectId" 
                        :show-select="isEdit ? false : true"
                        :single-select="form.subType == 'daily-repeat' ? true : false"
                        :search="searchArea"
                        :no-data-text="$t('noinfo')"
                        :no-results-text="$t('no_matching_records_found')"
                      >
                        <template v-slot:item.name="{ item }">
                          <v-chip 
                            v-if="item.statusBooking"
                            :color="item.statusBooking.color"
                            outlined
                            style="border: none;"
                          >
                            {{ item.statusBooking.text }}
                          </v-chip>
                        </template>
                      </v-data-table>
                    </div>
                    <div v-else class="mt-7">
                      <MarketPlan 
                        :isEdit="false"
                        :height="500"
                        :selectAreas.sync="form.selectedAreas" 
                        :isSelect="true"
                        :vacancyAreas="currentVacancyAreas"
                        :single-select="form.subType == 'daily-repeat' ? true : false"
                        :isHideSearch="true"
                        :searchText.sync="searchArea"
                        :tooltipStallId="'bookingTooltipStall'"
                        :isBooking="true"
                        searchPosition="left"
                      />
                    </div>
                  </template>
                </v-form>
              </v-stepper-content>
              <v-stepper-content step="3" class="px-2">
                <template v-if="$helper.currencyOptions.length > 1 && currentType.isDaily">
                  <div class="box-currency-select">
                    <div class="txt-title">{{ $t('payment.currency') }}:</div>
                    <CurrencySelect 
                      v-model="currencyCode"
                      :disabled="isEdit" 
                      @change="changeCurrencyCode"
                    />
                  </div>
                </template>
                <h3 :class="`${typeColor.textClass}`" class="mb-1"><b>{{ $t('booking.all_booking_stall') }}</b></h3>
                <template v-for="area of form.selectedAreas">
                  <v-chip :class="`chip-text ${ area.statusBooking.color } my-1 mx-1`">
                    <v-icon size="20" class="me-2">mdi-store-outline</v-icon>
                    {{ area.statusBooking.text }}
                  </v-chip>
                </template>
                <template v-if="currentType.isDaily">
                  <template v-if="form.subType == 'daily-repeat'">
                    <div style="font-size: 18px;" class="font-weight-bold mt-4">
                      {{ $t('booking.booking_repeat_from_date', { start: $moment(form.startDate).format('D MMM YYYY'), end: $moment(form.endDate).format('D MMM YYYY') }) }}
                      {{ $t('booking.booking_repeat_from_date_time', { dayCount: formAreaBookings.length, startTime: form.startTime, endTime: form.endTime }) }}
                    </div>
                    <div class="d-flex align-center jstify-space-between mt-4">
                      <v-alert
                        v-if="!isEdit"
                        border="left"
                        color="warning"
                        text
                        class="my-0 py-4"
                        style="font-size: 16px;"
                      >
                        {{ $t('booking.please_check_booking_repeat_and_bill') }}
                      </v-alert>
                      <v-spacer></v-spacer>
                      <v-switch
                        v-model="form.isAddItemAll"
                        color="success"
                        inset
                        :label="$t('bill.split_bill')"
                        @change="changeAddItemAll"
                        :disabled="isEdit"
                      >
                        <template v-slot:label>
                          <div class="d-flex align-center font-weight-bold" style="font-size: 20px;">
                            {{ form.isAddItemAll ? $t('bill.merge_bill') : $t('bill.split_bill') }}
                          </div>
                        </template>
                      </v-switch>
                    </div>
                  </template>
                  <div v-if="formAreaBookings && formAreaBookings.length" class="mt-4">
                    <div v-for="(data, index) in formAreaBookings" :class="`box-booking-area daily ${ data.isExpand ? 'expand' : ''} ${index == 0 ? 'first' : ''}`">
                      <div class="d-flex align-center justify-space-between">
                        <div style="font-size: 18px; font-weight: bold">{{ $t('booking.booking_detail_area_at', { index: index + 1 }) }} <span class="success--text">({{ data.area.name }})</span></div>
                        <div class="d-flex align-center">
                          <template v-if="!isEdit">
                            <div style="font-size: 18px; font-weight: bold">{{ $t('market.total_value') }} <span class="success--text">
                                {{ totalValue(data.invoice.items) | currencySuffixTextThEn(currencyCode) }}
                              </span>
                            </div>
                            <v-btn
                              icon
                              color="error"
                              class="bg-red-100 mx-2 ms-4"
                              @click="confirmRemoveAreaBooking(index)"
                            >
                              <v-icon size="20">mdi-trash-can-outline</v-icon>
                            </v-btn>
                          </template>
                          <v-icon v-if="data.isExpand" size="25" class="ms-2" @click="data.isExpand = false">mdi-chevron-up</v-icon>
                          <v-icon v-else size="25" class="ms-2" @click="data.isExpand = true">mdi-chevron-down</v-icon>
                        </div>
                      </div>
                      <div style="font-size: 18px;" class="my-2">
                        {{ $t('booking.booking_date_time_from_date', { start: $moment(data.startDate).format('D MMM YYYY'), end: $moment(data.endDate).format('D MMM YYYY'), startTime: data.startTime, endTime: data.endTime }) }}
                        ({{ diffDays({startDate: data.startDate, endDate: data.endDate, startTime: data.startTime, endTime: data.endTime}) }} {{ $t('day') }})
                      </div>
                      <div v-show="data.isExpand" class="mb-4">
                        <div class="mt-8 px-5 py-3" style="border: 3px solid var(--v-success-base); border-radius: 10px;">
                          <div class="d-flex justify-space-between align-center">
                            <div class="success--text" style="font-size: 20px;"><b>{{ $t('product.product_in_sell') }}</b></div>
                            <div style="width: calc(100% - 150px)">
                              <SelectProductInput
                                v-model="data.products"
                                :projectId="projectId"
                                :marketId="marketId"
                                :products="getProducts"
                                :label="$t('product.title')"
                                outlined
                                prepend-inner-icon="mdi-basket-outline"
                                :isAppendAction="false"
                                hide-details
                                chipColor="success"
                                color="success"
                              />
                            </div>
                          </div>
                        </div>
                        <div class="d-flex justify-space-between align-center mt-6">
                          <div style="width: 50%">
                            <AutocompleteArea
                              v-model="data.area"
                              :label="$t('area.empty_stall')" 
                              outlined
                              :items="currentVacancyAreas" 
                              :item-text="item => `${item.name} ${item.contract && item.contract.isSuspend ? `(${$t('suspend.stall_in_suspend')}) ` : ''} ${item.contract ? `(${$t('area.monthly_renter', { check: checkExpired(item.contract.endDate) })} ? ${$t('area.renter_end_date')} : ${$t('contract.in_contract')}} ${item.contract && item.contract.endDate ? dateFormat(item.contract.endDate.iso, $moment.defaultFormat, 'DD/MM/YYYY') : '-'})` : `(${$t('area.empty_stall')})`}`"
                              :item-value="item => item.objectId" 
                              :no-data-text="$t('area.no_empty_stall_in_date')"
                              chipType="text"
                              :isHideIcon="true"
                              disabled
                              :loading="isLoadSearch"
                              :clearable="false"
                              prepend-inner-icon="mdi-store-outline"
                              hide-details
                              return-object
                              readonly
                            />
                          </div>
                          <!-- <div>
                            <v-btn text :color="typeColor.color" @click="searchAllAvailableAreas(index)" :disabled="isLoadSearch">
                              <v-icon left>mdi-refresh</v-icon>
                              ค้นหาแผงว่างซ้ำ
                            </v-btn>
                          </div> -->
                        </div>
                        <v-card
                          v-if="data.area && !isEdit && !(form.subType == 'daily-repeat' && form.isAddItemAll && index != 0)"
                          class="px-0 py-0 border-2 mt-4" 
                          elevation="6"
                        >
                          <v-simple-table class="mx-0 my-0">
                            <template v-slot:default>
                              <thead class="table-item header rounded-2">
                                <tr>
                                  <th width="5%" class="text-center">{{ $t('product.rank_list') }}</th>
                                  <th width="20%">{{ $t('product.product_name') }}</th>
                                  <th width="8%" class="text-right">{{ $t('product.quantity') }}</th>
                                  <th width="8%">{{ $t('accounting_product.unit') }}</th>
                                  <th width="8%" class="text-right">{{ $t('product.unit_price') }}</th>
                                  <th width="8%" class="text-right">{{ $t('product.discount_unit') }}</th>
                                  <th width="8%">{{ $t('product.vat') }}</th>
                                  <th width="8%">{{ $t('accounting_product.withholding_tax') }}</th>
                                  <th width="8%" class="text-right">{{ $t('product.total_price') }}</th>
                                  <th width="4%" class="text-center"></th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr v-for="(item, indexItem) in data.invoice.items" :key="indexItem">
                                  <td class="py-2 px-2 text-center vertical-top">{{ indexItem + 1 }}</td>
                                  <td class="py-2 px-2 vertical-top">
                                    <v-text-field v-if="item.accountingProduct && item.dailyBillingSetting"
                                      v-model="item.accountingProduct.name" :placeholder="$t('product.product_name')" outlined dense
                                      hide-details disabled></v-text-field>
                                    <v-autocomplete v-else v-model="item.accountingProductId" :placeholder="$t('product.product_name')"
                                      :items="accountingProductOptions"
                                      :rules="[rules.required]" item-text="name" item-value="objectId" outlined dense
                                      hide-details :menu-props="{ closeOnContentClick: true }">
                                      <template v-slot:no-data>
                                        <v-list-item v-if="enableAddAccountingProduct">
                                          <v-list-item-title>
                                            <v-btn text color="green" block link @click="addProduct()">
                                              <v-icon left>mdi-plus-box-multiple</v-icon>{{ $t('area.add_service_list') }}
                                            </v-btn>
                                          </v-list-item-title>
                                        </v-list-item>
                                        <v-list-item v-else class="d-flex justify-center">
                                          {{ $t('bill.no_bill_list') }}
                                        </v-list-item>
                                      </template>
                                      
                                      <template v-slot:item="{ item }">
                                        <v-list-item v-if="item.isAddProduct">
                                          <v-list-item-title>
                                            <v-btn text color="green" block link @click="addProduct()">
                                              <v-icon left>mdi-plus-box-multiple</v-icon>{{ $t('area.add_service_list') }}
                                            </v-btn>
                                          </v-list-item-title>
                                        </v-list-item>
  
                                        <template v-else>
                                          <v-list-item @click="chooseItem(item, index, data.invoice.items[indexItem])"
                                            v-show="!item.obj.isRemoved">{{ item.name }}</v-list-item>
                                        </template>
                                      </template>
                                    </v-autocomplete>
                                    <template v-if="!item.dailyBillingSetting && isDuplicateItem(item, data.invoice.items)">
                                      <p class="mb-1"><small class="red--text">{{ $t('area.service_list_exist') }}</small></p>
                                    </template>
                                  </td>
                                  <td class="py-2 px-2 text-right vertical-top">
                                    <v-currency-field :placeholder="$t('product.quantity')" class="input-right input-disable-appearance" outlined
                                      dense hide-details v-model="item.number"
                                      @input="changeTotalOriginalValue(index, indexItem, data.invoice.items, true)"
                                      :rules="[rules.required]" />
                                  </td>
                                  <td class="py-2 px-2 vertical-top">
                                    <v-text-field v-model="item.unit" :placeholder="$t('accounting_product.unit')" outlined dense hide-details
                                      :value="$t('product.box')" :rules="[rules.required]"></v-text-field>
                                  </td>
                                  <td class="py-2 px-2 text-right vertical-top">
                                    <v-currency-field v-model="item.originalPricePerUnit" :placeholder="$t('product.unit_price')"
                                      class="input-right input-disable-appearance" outlined dense hide-details
                                      @input="changeTotalOriginalValue(index, indexItem, data.invoice.items, true)"
                                      :rules="[rules.required]" :disabled="item.type == 'discount'" :options="{ precision: {}}"/>
                                  </td>
                                  <td class="py-2 px-2 text-right vertical-top">
                                    <v-menu v-if="item.type != 'discount'" offset-y style="max-width: 600px">
                                      <template v-slot:activator="{ on, attrs }">
                                        <v-currency-field v-model="item.discountPerUnit" :placeholder="$t('product.discount_per_unit_price')"
                                          class="input-right input-disable-appearance" outlined dense hide-details
                                          @input="changeTotalOriginalValue(index, indexItem, data.invoice.items, true)"
                                          :suffix="item.discountType == 2 ? '%' : ''" v-bind="attrs" v-on="on"
                                          :rules="item.discountType == 2 ? [rules.maxDiscountPercent] : []" />
                                      </template>
                                      <v-card>
                                        <v-card-title class="px-3 py-2">
                                          <h5 class="my-0">{{ $t('product.select_discount_type') }}</h5>
                                        </v-card-title>
                                        <v-card-text class="px-4 py-0">
                                          <v-radio-group v-model="item.discountType" class="my-0 py-0 small-radio" column
                                            @change="changeTotalOriginalValue(index, indexItem, data.invoice.items, true)">
                                            <v-radio :label="$helper.currencyThEn()" :value="1"></v-radio>
                                            <v-radio :label="$t('percent')" :value="2"></v-radio>
                                          </v-radio-group>
                                        </v-card-text>
                                      </v-card>
                                    </v-menu>
                                    <v-currency-field v-else v-model="item.discountPerUnit" :placeholder="$t('product.discount_per_unit_price')"
                                      class="input-right input-disable-appearance" outlined dense hide-details
                                      @input="changeTotalOriginalValue(index, indexItem, data.invoice.items, true)"
                                      :disabled="item.refInvoiceBooking ? true : false" />
                                  </td>
                                  <td class="py-2 px-2 text-right vertical-top">
                                    <v-select v-model="item.sellVatType" :items="[
                                      {
                                        text: `${$globalVatPercent}%`,
                                        value: 1,
                                      },
                                      {
                                        text: '0%',
                                        value: 2,
                                      },
                                      {
                                        text: $t('except'),
                                        value: 3,
                                      },
                                    ]" item-text="text" item-value="value" :placeholder="$t('product.vat')" outlined dense
                                      hide-details :no-data-text="$t('noinfo')"></v-select>
                                  </td>
                                  <td class="py-2 px-2 text-right vertical-top">
                                    <v-select v-model="item.whtPercent"
                                      :items="form.customer && (form.customer.type != 'company' || market.disableWht) ? [{ name: $t('no'), value: 0 }] : taxWithheldOptions"
                                      item-text="name" item-value="value" :placeholder="$t('product.withholding')" outlined lang dense
                                      hide-details :no-data-text="$t('noinfo')">
                                      <template v-slot:selection="data">
                                        <div class="d-block w-100" style="width: 100%">
                                          <template v-if="data.item.value > 0">
                                            <div class="d-block w-100">
                                              {{ totalWhtValueIn(item) | currencySuffixTextThEn(currencyCode) }}
                                              <br />
                                            </div>
                                          </template>
                                          <div class="d-block w-100" :style="data.item.value > 0 ? 'font-size: 13px' : ''"
                                            :class="data.item.value > 0 ? 'text-right text-gray' : ''">{{ data.item.name }}
                                          </div>
                                        </div>
                                      </template>
                                    </v-select>
                                  </td>
                                  <td class="py-2 px-2 text-right vertical-top">
                                    <v-currency-field v-model="item.totalOriginalValue" :placeholder="$t('product.total_price')"
                                      class="input-right input-disable-appearance" outlined dense hide-details
                                      @input="changeTotalOriginalValue(index, indexItem)"
                                      :rules="[rules.required]" :prefix="item.type == 'discount' ? '' : ''" />
                                  </td>
                                  <td class="text-center">
                                    <v-icon class="mr-2"
                                      @click="deleteItem(data.invoice.items, indexItem)">mdi-trash-can-outline</v-icon>
                                  </td>
                                </tr>
                              </tbody>
                            </template>
                          </v-simple-table>
                          <v-divider></v-divider>
                          <v-card-actions>
                            <v-btn 
                              color="info"
                              @click="addItem(index)"
                            >
                              <v-icon left>mdi-plus</v-icon>{{ $t('area.add_row') }}
                            </v-btn>
                          </v-card-actions>
                        </v-card>
                        <template v-if="!isEdit">
                          <template v-if="form.subType == 'daily-repeat' && !form.isAddItemAll">
                            <div class="info--text mt-5" style="font-size: 18px;">{{ $t('booking.total_bill_per_repeat_booking', { count: formAddBookings.length }) }}</div>
                            <div class="rounded-lg px-5 py-4" style="border: 2px solid var(--v-info-base);">
                              <v-row no-gutters>
                                <v-col cols="3">
                                  <div class="border-r-2">
                                    <div>{{ $t('payment.total_amount') }}</div>
                                    <h4 class="info--text font-weight-bold">{{ totalOriginalValue(data.invoice.items) | currencySuffixTextThEn(currencyCode) }}</h4>
                                  </div>
                                </v-col>
                                <v-col cols="3" class="text-center">
                                  <div class="border-r-2">
                                    <div>{{ $t('payment.total_discount_amount') }}</div>
                                    <h4 class="info--text font-weight-bold">{{ totalDiscountValue(data.invoice.items) | currencySuffixTextThEn(currencyCode) }}</h4>
                                  </div>
                                </v-col>
                                <v-col cols="3" class="text-center">
                                  <div class="border-r-2">
                                    <div>{{ $t('product.vat') }}</div>
                                    <h4 class="info--text font-weight-bold">{{ totalVatValue(data.invoice.items) | currencySuffixTextThEn(currencyCode) }}</h4>
                                  </div>
                                </v-col>
                                <v-col cols="3" class="text-right">
                                  <div>
                                    <div><b>{{ $t('market.total_value') }}</b></div>
                                    <h4 class="info--text font-weight-bold">{{ totalValue(data.invoice.items) | currencySuffixTextThEn(currencyCode) }}</h4>
                                  </div>
                                </v-col>
                              </v-row>
                            </div>
  
                            <div class="success--text mt-5" style="font-size: 18px;">{{ $t('payment.your_total_amount') }}</div>
                            <div class="rounded-lg px-5 py-4" style="border: 2px solid var(--v-success-base);">
                              <v-row no-gutters>
                                <v-col cols="3">
                                  <div class="border-r-2">
                                    <div>{{ $t('payment.total_amount') }}</div>
                                    <h4 class="success--text font-weight-bold">{{ totalOriginalValue(allInvoiceItems) | currencySuffixTextThEn(currencyCode) }}</h4>
                                  </div>
                                </v-col>
                                <v-col cols="3" class="text-center">
                                  <div class="border-r-2">
                                    <div>{{ $t('payment.total_discount_amount') }}</div>
                                    <h4 class="success--text font-weight-bold">{{ totalDiscountValue(allInvoiceItems) | currencySuffixTextThEn(currencyCode) }}</h4>
                                  </div>
                                </v-col>
                                <v-col cols="3" class="text-center">
                                  <div class="border-r-2">
                                    <div>{{ $t('product.vat') }}</div>
                                    <h4 class="success--text font-weight-bold">{{ totalVatValue(allInvoiceItems) | currencySuffixTextThEn(currencyCode) }}</h4>
                                  </div>
                                </v-col>
                                <v-col cols="3" class="text-right">
                                  <div>
                                    <div><b>{{ $t('market.total_value') }}</b></div>
                                    <h4 class="success--text font-weight-bold">{{ totalValue(allInvoiceItems) | currencySuffixTextThEn(currencyCode) }}</h4>
                                  </div>
                                </v-col>
                              </v-row>
                            </div>
                          </template>
                          <template v-else-if="!(form.subType == 'daily-repeat' && form.isAddItemAll && index != 0)">
                            <div class="rounded-lg px-5 py-4 mt-7" style="border: 2px solid var(--v-success-base);">
                              <v-row no-gutters>
                                <v-col cols="3">
                                  <div class="border-r-2">
                                    <div>{{ $t('payment.total_amount') }}</div>
                                    <h4 class="success--text font-weight-bold">{{ totalOriginalValue(data.invoice.items) | currencySuffixTextThEn(currencyCode) }}</h4>
                                  </div>
                                </v-col>
                                <v-col cols="3" class="text-center">
                                  <div class="border-r-2">
                                    <div>{{ $t('payment.total_discount_amount') }}</div>
                                    <h4 class="success--text font-weight-bold">{{ totalDiscountValue(data.invoice.items) | currencySuffixTextThEn(currencyCode) }}</h4>
                                  </div>
                                </v-col>
                                <v-col cols="3" class="text-center">
                                  <div class="border-r-2">
                                    <div>{{ $t('product.vat') }}</div>
                                    <h4 class="success--text font-weight-bold">{{ totalVatValue(data.invoice.items) | currencySuffixTextThEn(currencyCode) }}</h4>
                                  </div>
                                </v-col>
                                <v-col cols="3" class="text-right">
                                  <div>
                                    <div><b>{{ $t('market.total_value') }}</b></div>
                                    <h4 class="success--text font-weight-bold">{{ totalValue(data.invoice.items) | currencySuffixTextThEn(currencyCode) }}</h4>
                                  </div>
                                </v-col>
                              </v-row>
                            </div>
                          </template>
                        </template>
                      </div>
                    </div>
                  </div>
                </template>
                <template v-if="currentType.isMonthly">
                  <div v-if="formAreaBookings && formAreaBookings.length" class="mt-4">
                    <div v-for="(data, index) in formAreaBookings" :class="`box-booking-area monthly ${ data.isExpand ? 'expand' : ''} ${index == 0 ? 'first' : ''}`">
                      <div class="d-flex align-center justify-space-between">
                        <div style="font-size: 18px; font-weight: bold">{{ $t('booking.booking_detail_area_at', { index: index + 1 }) }} <span :class="typeColor.textClass">({{ data.area.name }})</span></div>
                        <div>
                          <v-btn
                            v-if="!isEdit"
                            icon
                            color="error"
                            class="bg-red-100 mx-2"
                            @click="confirmRemoveAreaBooking(index)"
                          >
                            <v-icon size="20">mdi-trash-can-outline</v-icon>
                          </v-btn>
                          <v-icon v-if="data.isExpand" size="25" class="ms-2" @click="data.isExpand = false">mdi-chevron-up</v-icon>
                          <v-icon v-else size="25" class="ms-2" @click="data.isExpand = true">mdi-chevron-down</v-icon>
                        </div>
                      </div>
                      <div style="font-size: 18px;" class="my-2">
                        {{ $t('booking.booking_date') }} {{ $moment(data.startDate).format('D MMM YYYY') }} - {{ $moment(data.endDate).format('D MMM YYYY') }}
                        ({{ diffDays({startDate: data.startDate, endDate: data.endDate}) }} {{ $t('day') }})
                      </div>
                      <div v-show="data.isExpand" class="mt-8 px-5 py-3 mb-4" style="border: 3px solid var(--monthly-booking-base); border-radius: 10px;">
                        <div class="d-flex justify-space-between align-center">
                          <div :class="typeColor.textClass" style="font-size: 20px;"><b>{{ $t('product.product_in_sell') }}</b></div>
                          <div style="width: calc(100% - 150px)">
                            <SelectProductInput
                              v-model="data.products"
                              :projectId="projectId"
                              :marketId="marketId"
                              :products="getProducts"
                              :label="$t('product.title')"
                              outlined
                              prepend-inner-icon="mdi-basket-outline"
                              :isAppendAction="false"
                              hide-details
                              chipColor="info"
                              color="info"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </template>
              </v-stepper-content>

              <v-stepper-content step="4" class="px-2">
                <template v-if="currentType.isMonthly">
                  <div class="d-flex align-center justify-space-between">
                    <h3><b>{{ $t('booking.all_booking_stall') }}</b></h3>
                    <h3><b>{{ formAreaBookings.length }} {{ $t('area.space') }}</b></h3>
                  </div>
                  <div class="mt-8 px-5 py-3" style="border: 3px solid var(--monthly-booking-base); border-radius: 10px; font-size: 16px;">
                    <div class="my-1"><b>{{ $t('contract.business_name') }} : </b> {{ form.businessName }}</div>
                    <div class="my-1"><b>{{ $t('market.marchant_name') }} / {{ $t('company') }} : </b> {{ form.customer ? form.customer.fullName : '-' }}</div>
                    <div class="my-1"><b>{{ $t('booking.booking_channel') }} : </b> {{ form.bookingChannel ? form.bookingChannel.name : '-' }}</div>
                    <div class="my-1"><b>{{ $t('area.stall_type') }} : </b> {{ stallTypeLabel[form.stallType] || '-' }}</div>
                  </div>
                  <template v-if="formAreaBookings && formAreaBookings.length">
                    <div class="mt-6 px-5 py-3" style="border: 3px solid var(--monthly-booking-base); border-radius: 10px;">
                      <div v-for="(data, index) in formAreaBookings" class="mt-4">
                        <div class="d-flex align-center justify-space-between">
                          <div>
                            <div style="font-size: 18px;" class="font-weight-bold" :class="typeColor.textClass">{{ $t('market.market_title') }} {{ data.area.name }}</div>
                            <div class="d-flex align-center mt-2">
                              <div style="font-size: 16px;" class="mt-1" :class="typeColor.textClass">{{ $t('product.title') }}</div>
                              <div v-if="data.products && data.products.length">
                                <v-chip v-for="product in data.products" :key="product.id" :class="`chip-text ${typeColor.color} mx-1`">{{ product.name }}</v-chip>
                              </div>
                              <div v-else class="grey--text ms-2">-</div>
                            </div>
                          </div>
                          <div class="grey--text text-right">
                            <div>{{ $t('area.enter_stall_date') }} {{ $moment(data.startDate).format('D MMM YYYY') }} - {{ $moment(data.endDate).format('D MMM YYYY') }},
                              ({{ diffDays({startDate: data.startDate, endDate: data.endDate}) }} {{ $t('day') }}) x 1
                            </div>
                            <div>{{ $t('area.stall_size', { size: data.area.size }) }}</div>
                          </div>
                        </div>
                        <hr class="mb-6 mt-4" />
                      </div>
                    </div>
                  </template>
                </template>
                <template v-if="currentType.isDaily">
                  <h3 v-if="isEdit"><b>{{ $t('summary') }}</b></h3>
                  <h3 v-else><b>{{ $t('payment.summary_payment_list') }}</b></h3>
                  <div class="gap-5" :class="!isEdit ? 'd-flex' : ''">
                    <div class="box-booking-area daily expand py-4" style="height: fit-content; font-size: 16px" v-if="isEdit">
                      <div class="my-1"><b>{{ $t('contract.business_name') }} : </b> {{ form.businessName }}</div>
                      <div class="my-1"><b>{{ $t('market.marchant_name') }} / {{ $t('company') }} : </b> {{ form.customer ? form.customer.fullName : '-' }}</div>
                      <div class="my-1"><b>{{ $t('booking.booking_channel') }} : </b> {{ form.bookingChannel ? form.bookingChannel.name : '-' }}</div>
                    </div>
                    <div class="box-booking-area daily expand pb-6" style="height: fit-content" :style="!isEdit ? 'width: 57%;' : ''">
                      <template v-for="(data, index) in formAreaBookings">
                        <div class="border-b py-3">
                          <div class="d-flex justify-space-between">
                            <div class="daily-color font-weight-bold mb-3" style="font-size: 18px;">{{ $t('area.space') }} {{ data.area.name }}</div>
                            <div v-if="form.subType == 'daily-repeat'">
                              <span v-if="form.isAddItemAll" class="success--text font-weight-bold">{{ $t('bill.merge_bill') }}</span>
                              <span v-else class="info--text font-weight-bold">{{ $t('bill.split_bill') }}</span>
                            </div>
                          </div>
                          <div class="d-flex justify-space-between">
                            <div class="grey--text">
                              {{ $moment(data.startDate).format('D MMM YYYY') }} - {{ $moment(data.endDate).format('D MMM YYYY') }}, {{ data.startTime }} - {{ data.endTime }} {{ $t('timeunit.minute.short') }}
                              ({{ diffDays({startDate: data.startDate, endDate: data.endDate, startTime: data.startTime, endTime: data.endTime}) }} {{ $t('day') }})
                            </div>
                            <div class="success--text font-weight-bold" v-if="!isEdit">{{ totalValue(data.invoice.items) | currencySuffixTextThEn(currencyCode) }}</div>
                          </div>
                          <div class="d-flex align-center mt-2">
                            <div style="font-size: 16px;" class="mt-1" :class="typeColor.textClass">{{ $t('product.title') }}</div>
                            <div v-if="data.products && data.products.length">
                              <v-chip v-for="product in data.products" :key="product.id" :class="`chip-text ${typeColor.color} mx-1`">{{ product.name }}</v-chip>
                            </div>
                            <div v-else class="grey--text ms-2">-</div>
                          </div>
                        </div>
                      </template>
                    </div>
                    <div class="box-booking-area daily expand py-6" style="width: 43%; height: fit-content" v-if="!isEdit">
                      <v-row>
                        <v-col cols="7" class="py-0">
                          <p class="summary-topic">{{ $t('payment.total_amount') }}</p>
                        </v-col>
                        <v-col cols="5" class="py-0 text-right">
                          <p class="summary-number">{{ totalOriginalValue(allInvoiceItems) | currency }} {{ $helper.currencyThEn(currencyCode) }}</p>
                        </v-col>
                      </v-row>
                      <hr class="my-4" />
                      <v-row>
                        <v-col cols="7" class="py-0">
                          <p class="summary-topic">{{ $t('payment.total_discount_amount_value') }}</p>
                        </v-col>
                        <v-col cols="5" class="py-0 text-right">
                          <p class="summary-number">{{ totalDiscountValue(allInvoiceItems) | currency }} {{ $helper.currencyThEn(currencyCode) }}</p>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="7" class="py-0">
                          <p class="summary-topic">{{ $t('tax.tax_exempt_value') }}</p>
                        </v-col>
                        <v-col cols="5" class="py-0 text-right">
                          <p class="summary-number">{{ totalNonVatItemsValue(allInvoiceItems) | currency }} {{ $helper.currencyThEn(currencyCode) }}</p>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="7" class="py-0">
                          <p class="summary-topic">{{ $t('tax.tax_calculated_value') }}</p>
                        </v-col>
                        <v-col cols="5" class="py-0 text-right">
                          <p class="summary-number">{{ totalVatItemsValue(allInvoiceItems) | currencySuffixTextThEn(currencyCode) }}</p>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="7" class="py-0">
                          <p class="summary-topic">{{ $t('product.vat') }}</p>
                        </v-col>
                        <v-col cols="5" class="py-0 text-right">
                          <p class="summary-number">{{ totalVatValue(allInvoiceItems) | currencySuffixTextThEn(currencyCode) }}</p>
                        </v-col>
                      </v-row>
                      <hr class="my-4" />
                      <v-row>
                        <v-col cols="7" class="py-0">
                          <p class="summary-topic bold">{{ $t('market.total_value') }}</p>
                        </v-col>
                        <v-col cols="5" class="py-0 text-right">
                          <p class="summary-number bold">{{ totalValue(allInvoiceItems) | currencySuffixTextThEn(currencyCode) }}</p>
                        </v-col>
                      </v-row>
                      <div v-if="isWht(allInvoiceItems)">
                        <hr class="my-4" />
                        <v-row>
                          <v-col cols="7" class="py-0">
                            <p class="summary-topic">{{ $t('tax.tax_withholding') }}</p>
                          </v-col>
                          <v-col cols="5" class="py-0 text-right">
                            <p class="summary-number">{{ totalWhtValue(allInvoiceItems) | currencySuffixTextThEn(currencyCode) }}</p>
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col cols="7" class="py-0">
                            <p class="summary-topic bold">{{ $t('payment.total_amount_to_pay') }}</p>
                          </v-col>
                          <v-col cols="5" class="py-0 text-right">
                            <p class="summary-number bold">
                              {{ totalValue(allInvoiceItems) - totalWhtValue(allInvoiceItems) | currencySuffixTextThEn(currencyCode) }}
                            </p>
                          </v-col>
                        </v-row>
                      </div>
                    </div>
                  </div>
                </template>
              </v-stepper-content>
            </v-stepper-items>
          </v-stepper>
        </v-card-text>

        <v-divider></v-divider>
        <v-card-actions v-if="!booking || (booking && isEdit)">
          <v-btn
            v-if="step > 1"
            text
            @click="step--"
          >
            {{ $t('back') }}
          </v-btn>
          <v-spacer></v-spacer>
          <div class="font-weight-bold me-3" v-if="step == 3 && currentType.isDaily && !isEdit">
            {{ $t('payment.total_amount_all') }} <span class="success--text">{{ totalValue(allInvoiceItems) | currencySuffixTextThEn(currencyCode) }}</span>
          </div>
          <template v-if="isEdit">
            <div class="error--text me-3" v-if="unAvailableAreas && unAvailableAreas.length">
              {{ $t('area.not_available_stall') }} {{ unAvailableAreas.map(d => d.name).join(', ') }}
            </div>
            <v-btn
              :color="typeColor.color"
              :disabled="unAvailableAreas.length > 0 || isLoading"
              @click="saveBooking()"
            >
              {{ $t('save') }}
            </v-btn>
          </template>
          <template v-else>
            <v-btn
              v-if="step < 4"
              :color="typeColor.color"
              @click="nextStep(step)"
              :disabled="isLoadBillingSettings"
              :loading="isLoadBillingSettings"
            >
              {{ $t('next') }}
            </v-btn>
            <v-btn
              v-if="step == 4"
              :color="typeColor.color"
              :disabled="isLoading"
              @click="saveBooking()"
            >
              {{ $t('save') }}
            </v-btn>
          </template>
        </v-card-actions>

        <v-card-text style="margin:0;padding:15px;" min-height="600" v-if="booking && !isEdit">
          <v-row>
            <v-col :cols="currentType.isDaily ? 6 : 12">
              <v-card style="padding:0;">
                <v-card-title class="d-flex justify-space-between daily-color bg-green-100">
                  <div>{{ $t('booking.booking_detail') }}</div>
                  <div>
                    <v-btn :color="isEdit ? 'error' : 'warning'" style="margin-right:10px;"
                      :disabled="statusBtn.edit || isMainLoading || booking.status == 'cancelled' || booking.contract ? true : false"
                      @click="clickEdit(!isEdit)">{{ isEdit ? $t('account.cancel_edit') : $t('booking.edit_booking') }}</v-btn>
                    <v-btn color="error"
                      :disabled="statusBtn.cancel || isMainLoading || booking.status == 'cancelled' || booking.status == 'success' || isEdit || booking.contract ? true : false"
                      @click="isCancelConfirm = true">{{ $t('booking.cancel_booking') }}</v-btn>
                  </div>
                </v-card-title>
                <v-card-text style="margin:0;padding:0;">
                  <customer-card v-if="form.customer" :emails="form.customer.emails" :firstName="form.customer.firstName"
                    :lastName="form.customer.lastName" :tels="form.customer.tels" :companyName="form.customer.companyName"
                    :type="form.customer.type" :interTels="form.customer.interTels"
                    :img="form.customer.profileImages && form.customer.profileImages[0] ? form.customer.profileImages[0].url : '/user.png'"
                    :url="`/project/${projectId}/market/${marketId}/customer/${form.customer.objectId}/view`"></customer-card>
                  <div style="padding:15px;" class="bg-gray-100">
                    <div>
                      {{ $t('booking.booking_number') }} :
                      <v-chip :color="booking.status == 'cancelled' ? 'rgb(248,218,218)' : 'rgba(2, 156, 229,.2)'"
                        :class="booking.status == 'cancelled' ? 'red--text' : 'monthly-color'" style="margin-right:5px;">{{
                          booking.documentId || '-' }}</v-chip>
                    </div>
                    <div>{{ $t('contract.business_name') }} : {{ booking.businessName ? booking.businessName : '-' }}</div>
                    <div v-if="booking.bookingChannel">{{ $t('booking.booking_channel') }} : {{ booking.bookingChannel.name }}</div>
                    <div v-if="booking.stallType">{{ $t('area.stall_type') }} : {{ stallTypeLabel[booking.stallType] || '-' }}</div>
                    <div v-if="booking.note">{{ $t('note') }} : {{ booking.note }}</div>
                    <div>{{ $t('booking.booking_by') }} : {{ fullName(booking.createdBy) || '-' }}</div>
                    <div>{{ $t('booking.booking_at') }} : {{ dateFormat(booking.createdAt, $moment.defaultFormat) || '-' }}</div>
                    <div class="flex justify-end" v-show="false">
                      <v-btn color="info" @click="isPrintDialog = true"
                        :disabled="booking.status == 'cancelled'">{{ $t('booking.print_booking') }}</v-btn>
                    </div>
                    <div>{{ $t('contract.contract_number_only') }} : {{ booking.contract ? booking.contract.contractId : '-' }}</div>
                  </div>
                </v-card-text>
              </v-card>
            </v-col>
            <v-col cols="6" v-if="currentType.isDaily">
              <div class="mb-3" v-for="currency in $helper.currencyOptions" :key="currency.value">
                <v-card v-if="checkHasInvoice(currency.value)">
                  <v-card-title class="blue-grey--text bg-blue-100">{{ $t('payment.payment_detail') }}</v-card-title>
                  <v-card-text v-if="form.invoices && form.invoices.length">
                    <div v-if="sumField(form.invoices, 'totalUnpaidValue', null, currency.value) > 0"
                      class="flex justify-center text-xl text-red-600" style="margin:20px 0;">{{ $t('payment.pending') }}
                      {{ sumField(form.invoices, 'totalUnpaidValue', null, currency.value) | currencySuffixTextThEn(currency.value) }}</div>
                    <template v-if="sumField(form.invoices, 'totalPaidValue', null, currency.value) > 0">
                      <div class="flex justify-center text-xl text-screamin-green-700"
                        style="margin-top:20px;padding:0 0 20px;">{{ $t('payment.paid') }} {{ sumField(form.invoices, 'totalPaidValue', null, currency.value) | currencySuffixTextThEn(currency.value) }}</div>
                      <div v-for="(invoice, iInv) in form.invoices" :key="iInv">
                        <div v-for="(receipt, iRec) in invoice.receipts" :key="iRec">
                          <div v-if="receipt.isPaid && receipt.paymentMethod && receipt.currencyCode == currency.value">
                            {{ $t('payment.paid_payment_total_date', 
                            { total: $options.filters.currencySuffixTextThEn(receipt.totalValue, currency.value),
                             method: paymentMethods[receipt.paymentMethod] || '-', date: dateFormat(receipt.createdAt, $moment.defaultFormat) }) }}
                          </div>
                        </div>
                      </div>
                    </template>
                    <div style="margin-top:10px;">{{ $t('invoice.total_invoice_amount') }} {{ sumField(form.invoices, 'totalValue', null, currency.value) | currencySuffixTextThEn(currency.value) }}</div>
                  </v-card-text>
                  <v-card-text v-else>
                    <div class="text-lg text-center p-5">{{ $t('invoice.no_invoice_bill') }}</div>
                  </v-card-text>
                </v-card>
                <v-card v-else-if="!checkHasInvoice(currency.value) && currency.value == $globalCurrencyCode">
                  <v-card-title class="blue-grey--text bg-blue-100">{{ $t('payment.payment_detail') }}</v-card-title>
                  <v-card-text v-if="form.invoices && form.invoices.length">
                    <div v-if="sumField(form.invoices, 'totalUnpaidValue', null, currency.value) > 0"
                      class="flex justify-center text-xl text-red-600" style="margin:20px 0;">{{ $t('payment.pending') }}
                      {{ sumField(form.invoices, 'totalUnpaidValue', null, currency.value) | currencySuffixTextThEn(currency.value) }}</div>
                    <template v-if="sumField(form.invoices, 'totalPaidValue', null, currency.value) > 0">
                      <div class="flex justify-center text-xl text-screamin-green-700"
                        style="margin-top:20px;padding:0 0 20px;">{{ $t('payment.paid') }} {{ sumField(form.invoices, 'totalPaidValue', null, currency.value) | currencySuffixTextThEn(currency.value) }}</div>
                      <div v-for="(invoice, iInv) in form.invoices" :key="iInv">
                        <div v-for="(receipt, iRec) in invoice.receipts" :key="iRec">
                          <div v-if="receipt.isPaid && receipt.paymentMethod">
                            {{ $t('payment.paid_payment_total_date', 
                            { total: $options.filters.currencySuffixTextThEn(receipt.totalValue, currency.value),
                            method: paymentMethods[receipt.paymentMethod] || '-', date: dateFormat(receipt.createdAt, $moment.defaultFormat) }) }}
                          </div>
                        </div>
                      </div>
                    </template>
                    <div style="margin-top:10px;">{{ $t('invoice.total_invoice_amount') }} {{ sumField(form.invoices, 'totalValue', null, currency.value) | currencySuffixTextThEn(currency.value) }}</div>
                  </v-card-text>
                  <v-card-text v-else>
                    <div class="text-lg text-center p-5">{{ $t('invoice.no_invoice_bill') }}</div>
                  </v-card-text>
                </v-card>
              </div>
            </v-col>
            <v-col cols="12" class="flex justify-space-between align-center" style="padding-bottom:0;">
              <h4>{{ $t('booking.booking_list') }}</h4>
              <div v-if="currentType.isMonthly && !isEdit && booking.status != 'success'">
                <template v-if="booking.contract">
                  <v-btn color="warning" class="mx-1" large :disabled="booking.status == 'cancelled' || isEdit"
                    @click="editContractDialog = true">
                    <v-icon left>mdi-file-edit</v-icon>
                    {{ $t('contract.edit_contract') }}
                  </v-btn>
                </template>
                <template v-if="!booking.contract">
                  <v-btn color="info" class="mx-1" large v-if="isAreasOccupied"
                    :disabled="booking.status == 'cancelled' || isEdit" @click="onCreateContract()">
                    <v-icon left>mdi-clipboard-check-multiple-outline</v-icon>
                    {{ $t('contract.make_contract') }}
                  </v-btn>
                  <v-btn color="success" class="mx-1" large v-if="!isAreasOccupied"
                    :disabled="booking.status == 'cancelled' || isEdit" @click="onCheckinMonthlyBooking()">
                    <v-icon left>mdi-clipboard-arrow-right-outline</v-icon>
                    {{ $t('contract.make_contract_stall') }}
                  </v-btn>
                </template>
              </div>
            </v-col>
            <v-col cols="12" v-if="form.contract && form.status != 'success'">
              <v-card>
                <v-card-title>{{ $t('contract.contract_detail') }}</v-card-title>
                <v-card-text>
                  <div>
                    <div>
                      <div>{{ $t('contract.contract_number_only') }} : {{ form.contract ? form.contract.contractId : '-' }}</div>
                      <div>{{ $t('contract.business_name') }} : {{ form.contract.businessName }}</div>
                      <div>{{ $t('customer.company_name_and_customer_name') }} : {{ form.contract.billingData.name }}</div>
                      <div>{{ $t('contract.start_date') }} : {{ $moment(form.contract.startDate.iso).format("D/MM/YYYY") }}</div>
                      <div>{{ $t('contract.end_date') }} : {{ $moment(form.contract.endDate.iso).format("D/MM/YYYY") }}</div>
                    </div>
                    <div class="flex justify-space-between align-center" style="margin-top:30px;">
                      <h4>{{ $t('bill.bill_list') }}</h4>
                      <v-btn color="info" @click="isBillingSelect = true" :disabled="booking.status == 'cancelled'">
                        <v-icon left>mdi-plus</v-icon>{{ $t('bill.add_new_bill') }}
                      </v-btn>
                    </div>
                    <v-data-table 
                      :headers="billListHeaders"
                      :items="invoiceContract || []"
                      class="my-3 border-2 cursor-pointer"
                      :items-per-page="10"
                      :loading="isLoading"
                      :no-data-text="$t('noinfo')"
                      :no-results-text="$t('no_matching_records_found')"
                      @click:row="openInvoice">
                      <template v-slot:item.date="{ item }">
                        <template v-if="item.date">
                          {{ $moment(item.date).format("DD/MM/YYYY") }}
                        </template>
                      </template>
                      <template v-slot:item.dueDate="{ item }">
                        <template v-if="item.dueDate">
                          {{ $moment(item.dueDate).format("DD/MM/YYYY") }}
                        </template>
                      </template>

                      <template v-slot:item.status="{ item }">
                        <v-chip :class="item.statusClass.class" :color="item.statusClass.color">{{ item.statusClass.text
                        }}</v-chip>
                        <v-chip class="ms-1 px-0 py-0" color="rgb(255, 137, 59, 0.3)" v-if="item.invoicePayment">
                          <img width="32" :src="require(`../assets/images/money-sign-orange.svg`)" />
                        </v-chip>
                      </template>
                      <template v-slot:item.totalValue="{ item }">
                        {{ item.totalValue | currencyPrefixSign(item.currencyCode) }}
                      </template>
                      <template v-slot:item.totalUnpaidValue="{ item }">
                        {{ item.totalUnpaidValue | currencyPrefixSign(item.currencyCode) }}
                      </template>
                    </v-data-table>
                  </div>
                </v-card-text>
              </v-card>
            </v-col>
            <v-col cols="12">
              <v-card>
                <v-card-title>{{ $t('booking.booking_data_detail') }}</v-card-title>
                <v-card-text>
                  <div v-for="(areaBooking, index) in booking.areaBookings" :key="'area-booking-' + index"
                    class="flex justify-space-between align-center booking-box-non">
                    <div>
                      <v-tooltip top v-if="areaBooking.contractSuspend">
                        <template v-slot:activator="{ on, attrs }">
                          <div v-bind="attrs" v-on="on">
                            <v-chip color="warning" class="mb-1">{{ $t('suspend.booking_from_suspend_stall') }}</v-chip>
                          </div>
                        </template>
                        <div>
                          {{ $t('area.from_date_that') }}
                          <u>{{ $t('suspend.suspend_and_sale_stall') }}</u>
                          {{ $t('area.in_date', { date: suspendDateFormat(areaBooking.contractSuspend) }) }}
                        </div>
                      </v-tooltip>
                      <div>
                        {{ $t('market.market_title') }}
                        <b v-if="areaBooking.area">{{ areaBooking.area.name || '-' }}</b>
                        <template v-if="booking.areaBookings && booking.areaBookings[0]">
                          <v-chip style="margin:0 5px;" v-for="product in areaBooking.products" :key="product.objectId">{{
                            product.name }}</v-chip>
                        </template>
                      </div>
                      <div>
                        {{ currentType.isDaily ? $t('booking.booking_date') : $t('contract.start_date') }}
                        <span v-if="areaBooking.startDate" class="underline"><b>{{ dateFormat(areaBooking.startDate.iso,
                          $moment.defaultFormat
                          , currentType.isDaily ? `dddd ${$t('at')} DD MMM YYYY HH:mm` : `dddd ${$t('at')} DD MMM YYYY`) }}</b></span>
                        {{ $t('to') }}
                        <span v-if="areaBooking.endDate">{{ dateFormat(areaBooking.endDate.iso, $moment.defaultFormat,
                          currentType.isDaily
                            ? 'DD MMM YYYY HH:mm' : 'DD MMM YYYY') }}</span>
                        ({{ diffDaysIso(areaBooking) }} {{ $t('day') }})
                      </div>
                      <div>{{ $t('area.enter_stall') }} : {{ areaBooking.checkedInDate ?
                        dateFormat(areaBooking.checkedInDate.iso, $moment.defaultFormat) : '-' }} {{ $t('by') }} :
                        {{ areaBooking.checkedInBy ? fullName(areaBooking.checkedInBy) : '-' }}</div>
                      <div v-if="currentType.isDaily">{{ $t('area.exit_stall') }} : {{ areaBooking.checkedOutDate ?
                        dateFormat(areaBooking.checkedOutDate.iso, $moment.defaultFormat) : '-' }} {{ $t('by') }} :
                        {{ areaBooking.checkedOutBy ? fullName(areaBooking.checkedOutBy) : '-' }}</div>
                    </div>
                    <template v-if="currentType.isDaily">
                      <v-btn v-if="!areaBooking.checkedInDate"
                        :disabled="booking.status == 'cancelled' || isEdit || (areaBooking.area && areaBooking.area.areaBooking) ? true : false"
                        color="success" @click="checkInArea(areaBooking)"
                        :loading="isLoading || isMainLoading">{{ $t('area.enter_stall') }}</v-btn>
                      <v-btn
                        v-if="areaBooking.checkedInDate && !areaBooking.checkedOutDate && booking.status != 'success'"
                        color="error" :disabled="booking.status == 'cancelled' || isEdit"
                        @click="checkOutArea(areaBooking)" :loading="isLoading || isMainLoading">{{ $t('area.exit_stall') }}</v-btn>
                    </template>
                    <template v-if="currentType.isMonthly">
                      <v-btn v-if="!areaBooking.checkedInDate && booking.contract"
                        :disabled="booking.status == 'cancelled' || isEdit || (areaBooking.area && areaBooking.area.areaBooking) ? true : false"
                        color="success" @click="checkInArea(areaBooking)"
                        :loading="isLoading || isMainLoading">{{ $t('area.enter_stall') }}</v-btn>
                    </template>
                  </div>
                  <div>
                    <div class="flex justify-space-between align-center" style="margin-top:30px;">
                      <h4>{{ $t('booking.booking_bill_list') }}</h4>
                      <v-btn color="info" @click="addInvoice(booking)" :disabled="booking.status == 'cancelled'">
                        <v-icon left>mdi-plus</v-icon>{{ $t('booking.add_booking_bill') }}
                      </v-btn>
                    </div>
                    <v-data-table
                      :headers="billListHeaders"
                      :items="form.invoices || []"
                      class="my-3 border-2 cursor-pointer"
                      :items-per-page="10"
                      :loading="isLoading"
                      :no-data-text="$t('noinfo')"
                      :no-results-text="$t('no_matching_records_found')"
                      @click:row="openInvoice">
                      <template v-slot:item.date="{ item }">
                        <template v-if="item.date">
                          {{ $moment(item.date).format("DD/MM/YYYY") }}
                        </template>
                      </template>
                      <template v-slot:item.dueDate="{ item }">
                        <template v-if="item.dueDate">
                          {{ $moment(item.dueDate).format("DD/MM/YYYY") }}
                        </template>
                      </template>

                      <template v-slot:item.status="{ item }">
                        <v-chip :class="item.statusClass.class" :color="item.statusClass.color">{{ item.statusClass.text
                        }}</v-chip>
                        <v-chip class="ms-1 px-0 py-0" color="rgb(255, 137, 59, 0.3)" v-if="item.invoicePayment">
                          <img width="32" :src="require(`../assets/images/money-sign-orange.svg`)" />
                        </v-chip>
                      </template>
                      <template v-slot:item.totalValue="{ item }">
                        {{ item.totalValue | currencyPrefixSign(item.currencyCode) }}
                      </template>
                      <template v-slot:item.totalUnpaidValue="{ item }">
                        {{ item.totalUnpaidValue | currencyPrefixSign(item.currencyCode) }}
                      </template>
                    </v-data-table>
                  </div>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-card-text>

        <v-dialog 
          v-model="isRemoveAreaBookingDialog" 
          max-width="450"
          persistent
        >
          <v-card class="pt-7 pb-1">
            <v-card-text>

              <div class="d-flex justify-center align-center">
                <div class="rounded-circle d-flex justify-center align-center px-5 py-5" style=" background-color: var(--v-bgError-base);">
                  <v-icon size="70" color="error">mdi-trash-can-outline</v-icon>
                </div>
                
                
              </div>
              <div class="text-center mt-6 font-weight-bold black--text" style="font-size: 20px;">{{ $t('booking.confirm_cancel_booking') }}</div>
              <div class="text-center mt-2" style="font-size: 16px;">{{ $t('booking.confirm_cancel_booking_stall') }}</div>
              <v-row class="mt-4 px-4">
                <v-col cols="6" class="d-flex justify-center align-center">
                  <v-btn style="width: 170px;" color="error" outlined @click="isRemoveAreaBookingDialog = false">{{ $t('cancel') }}</v-btn>
                </v-col>
                <v-col cols="6" class="d-flex justify-center align-center">
                  <v-btn style="width: 170px;" color="error" elevation="0" @click="removeAreaBooking(tempIndex)">{{ $t('confirm') }}</v-btn>
                </v-col>
              </v-row>
            </v-card-text>

          </v-card>
        </v-dialog>

        <v-dialog 
          v-model="isPreviewRepeatDialog" 
          max-width="700"
          content-class="right-dialog rounded-r-0" 
          transition="slide-x-reverse-transition" 
          scrollable
          persistent
        >
          <v-card style="height: 100vh;" class="rounded-r-0">
            <v-card-title
              :class="`d-flex justify-space-between align-center white--text`"
              :style="`background-color: var(--daily-booking-base)`"
            >
              {{ $t('booking.booking_date_can_booking') }}
            </v-card-title>
            <v-card-text class="py-4 px-6">
              <div class="mt-2" style="font-size: 18px;">
                {{ $t('booking.booking_date') }} {{ $moment(form.tempStartDate).format('D MMM YYYY') }} - {{ $moment(form.tempEndDate).format('D MMM YYYY') }}, {{ form.tempStartTime }} - {{ form.tempEndTime }}
                <b v-if="eventAvailableAreas">{{ $t('all') }} {{ eventAvailableAreas.all.filter(d => d.isAvailable).length }} {{ $t('day') }}</b>
              </div>
              <div class="d-flex align-center justify-space-between mt-4">
                <div class="black--text font-weight-bold" style="font-size: 18px;">{{ $t('booking.want_booking_stall') }}</div>
                <v-alert
                  v-if="form.selectedAreas && form.selectedAreas[0]"
                  border="left"
                  :color="form.selectedAreas[0].statusBooking.color"
                  text
                  class="my-0 py-3"
                  style="font-size: 18px;"
                >
                  <v-icon :color="form.selectedAreas[0].statusBooking.color" style="font-size: 28px;">
                    {{ form.selectedAreas[0].statusBooking.bookingIcon || form.selectedAreas[0].statusBooking.icon }}
                  </v-icon>
                  {{ form.selectedAreas[0].statusBooking.text }}
                </v-alert>
              </div>
              <hr class="my-4" />
              <v-row class="mt-2 mb-2" style="font-size: 16px;">
                <v-col class="info--text d-flex" cols="4">
                  <div class="me-1"><v-icon color="info" style="font-size: 28px;">mdi-circle</v-icon></div>
                  <div>{{ $t('contract.color_out_of_contract_can_booking_in_advance') }}</div>
                </v-col>
                <v-col class="success--text d-flex" cols="4">
                  <div class="me-1"><v-icon color="success" style="font-size: 28px;">mdi-circle</v-icon></div>
                  <div>{{ $t('booking.empty_stall_can_booking') }}</div>
                </v-col>
                <v-col class="error--text d-flex" cols="4">
                  <div class="me-1"><v-icon color="error" style="font-size: 28px;">mdi-circle</v-icon></div>
                  <div>{{ $t('contract.have_renter_not_end_contract_can_not_booking') }}</div>
                </v-col>
              </v-row>
              <CustomDatePicker
                :startDate="eventAvailableAreas.startDate"
                :endDate="eventAvailableAreas.endDate"
                available
                :color="'success'"
                :events="eventAvailableAreas.all"
              />
              <hr class="my-4" />
              <div v-for="key in Object.keys(eventAvailableAreas.months)">
                <div v-if="eventAvailableAreas.months[key].length" class="d-flex justify-start align-center mt-2">
                  <div>
                    <div style="font-size: 16px; width: 100px; color: var(--v-primary-base);">
                      <b>{{ $moment(key + '-01', 'YYYY-MM-DD').format('MMM YYYY') }}</b>
                    </div>
                  </div>
                  <div>
                    <v-chip v-for="item of eventAvailableAreas.months[key]" 
                      class="ma-1 px-4 py-2 chip-text"
                      :color="item.color"
                      style="font-size: 15px;"
                      :key="item.date"
                    >
                    {{ $moment(item.date).date() }}
                  </v-chip>
                  </div>
                </div>
              </div> 
            </v-card-text>
            <v-card-actions style="width: 100%;">
              <v-row class="px-6">
                <v-col cols="6">
                  <v-btn
                    outlined
                    large
                    color="error"
                    block
                    @click="isPreviewRepeatDialog = false"
                  >
                    {{ $t('booking.cancel_booking') }}
                  </v-btn>
                </v-col>
                <v-col cols="6">
                  <v-btn
                    color="primary"
                    large
                    block
                    :loading="isLoadBillingSettings"
                    :disabled="!eventAvailableAreas.all.find(d => d.color == 'success' || d.color == 'info') || isLoadBillingSettings"
                    @click="onConfirmRepeatBooking()"
                  >
                    {{ $t('booking.confirm_booking') }}
                  </v-btn>
                </v-col>
              </v-row>
            </v-card-actions>
          </v-card>
        </v-dialog>

      </v-card>
    </v-dialog>

    <v-dialog v-model="repeatBookingStatusDialog" max-width="500" scrollable persistent :disabled="false">
      <v-card>
        <v-card-title
          :class="`flex justify-space-between align-center  white--text`"
          :style="`background-color: ${currentType.isMonthly ? 'var(--monthly-booking-base)' : currentType.isDaily ? 'var(--daily-booking-base)' : ''}`"
        >
          <div>{{ $t('booking.warning_booking_repeat') }}</div>
          <v-btn color="white" icon @click="repeatBookingStatusDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="repeat-booking">
          <div v-if="reBookingRes && reBookingRes.isShow">
            <div v-if="reBookingRes.error && reBookingRes.error.length" class="repeat-error">
              <div class="repeat-error-header">{{ $t('area.stall_not_available') }} <v-icon color="error">mdi-close-thick</v-icon></div>
              <v-chip v-for="(reBookingResError, reBookingResIndex) in reBookingRes.error"
                :key="`chip-res-error-booking-${reBookingResIndex}`" color="error" class="mb-2">
                <v-icon left>mdi-close-thick</v-icon>
                {{ reBookingResError.repeatBookingStatus }}
              </v-chip>
            </div>
            <div v-if="reBookingRes.warning && reBookingRes.warning.length" class="repeat-warning">
              <div class="repeat-warning-header">{{ $t('area.notice_stall') }} <v-icon color="warning">mdi-alert</v-icon></div>
              <v-chip class="m-2 my-1" v-for="(reBookingResWarning, reBookingResIndex) in reBookingRes.warning"
                :color="reBookingResWarning.statusBooking.color" :key="`chip-res-warning-booking-${reBookingResIndex}`">
                <v-icon left>{{ reBookingResWarning.statusBooking.icon }}</v-icon>
                {{ $t('area.space') }} {{ reBookingResWarning.statusBooking.text }}
              </v-chip>
            </div>
          </div>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="success" @click="repeatBookingStatusDialog = false">
            {{ $t('confirm') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <select-customer v-model="searchDialog" @select="selectCustomer" :header="$t('customer.select_customer')"></select-customer>
    <booking-area-products v-if="bookingAreaProductsIndex > -1" v-model="bookingAreaProductsDialog"
      :formData="form.data[bookingAreaProductsIndex]" @onSave="saveProduct"></booking-area-products>
    <booking-channel v-model="bookingChannelDialog" :formData="form.bookingChannel"
      @onSave="saveBookingChannel"></booking-channel>
    <invoice-dialog-component :projectId="projectId" :documentType="currentType.isMonthly ? 8 : 7"
      v-model="isInvoiceDialog" :invoiceId="currentInvoiceId" :bookingId="currentBookingId"
      :contractData="currentContractData" @onSaveSuccess="onSaveSuccess"
      @onRemoveSuccess="onSaveSuccess"></invoice-dialog-component>
    <ConfirmDialog v-model="isCancelConfirm" :title="$t('booking.confirm_cancel_booking_renter')" :textBtnOk="$t('yes')" :textBtnCancel="$t('close')"
      type="error" @onOk="cancelBookingFn" />
    <form-contract event="create" v-model="addContractDialog" :booking="booking" :customer="form.customer"
      :isNotCheckInArea="isNotCheckInArea" @onCreateSuccess="contractSuccess"></form-contract>
    <form-contract event="edit" v-if="form.contract" v-model="editContractDialog" :obj="form.contract"
      :isNotUpdateStore="true" @onUpdated="onUpdateContract"></form-contract>
    <FormBookingChannel v-model="isChannel" @onLoad="loadBookingChannel" :event="`create`"></FormBookingChannel>
    <PrintDialog v-if="booking" elementId="print-booking" type="booking" v-model="isPrintDialog"
      :bookingId="booking.objectId" />
    <AccountingProductManageDialog v-model="isDialogAccountingProduct" :projectId="projectId"
      @onSaveSuccess="isSuccess = true" @onError="isError = true" />
    <BillingSelect v-if="form.contract" v-model="isBillingSelect" :contract="form.contract"
      @onSaveSuccess="loadContractInvoice()" @onRemoveSuccess="loadContractInvoice()" />
  </div>
</template>

<script>
import Helper from "../plugins/Helper/Helper";
import { Customer, DocumentItem, Invoice } from "../classes";
import { mapGetters, mapState, mapActions } from "vuex";
import CustomerCard from "./CustomerCard.vue";
import SelectCustomer from "./SelectCustomer.vue";
import BookingAreaProducts from "./BookingAreaProducts.vue";
import BookingChannel from "./BookingChannel.vue";
import FormBookingChannel from "./FormBookingChannel.vue";
import InvoiceDialogComponent from "./InvoiceDialog.component.vue";
import ConfirmDialog from "./ConfirmDialog.component";
import FormContract from "./FormContract.vue";
import PrintDialog from "./PrintDialog.component";
import AccountingProductManageDialog from "./AccountingProductManageDialog.component";
import AutocompleteArea from "./AutocompleteArea.vue";
import BillingSelect from "./BillingSelect.vue";
import LatestBookings from "./LatestBookings.vue";
import CustomerCard2 from "./CustomerCard2.vue";
import SelectCustomerInput from "./SelectCustomerInput.vue";
import SelectProductInput from "./SelectProductInput.vue";
import SelectViewType from "./SelectViewType.vue";
import SelectLoopDate from "./SelectLoopDate.vue";
import CustomDatePicker from "./CustomDatePicker.vue";
import CurrencySelect from "./CurrencySelect.vue";
export default {
  components: {
    CustomerCard,
    SelectCustomer,
    BookingAreaProducts,
    InvoiceDialogComponent,
    BookingChannel,
    FormBookingChannel,
    ConfirmDialog,
    FormContract,
    PrintDialog,
    AccountingProductManageDialog,
    AutocompleteArea,
    BillingSelect,
    LatestBookings,
    CustomerCard2,
    SelectCustomerInput,
    SelectProductInput,
    SelectViewType,
    SelectLoopDate,
    CustomDatePicker,
    MarketPlan: () => import('@/components/MarketPlan.vue'),
    CurrencySelect
  },
  data() {
    return {
      rules: {
        select: [v => !!v || this.$t('validate.required_input')],
        select3: [v => !!v || this.$t('validate.required_select')],
        select2: [v => v.length > 0 || this.$t('validate.required_select')],
        required: value => !!value || this.$t('validate.please_input_data'),
        maxDiscountPercent: v => v <= 100 || this.$t('validate.please_max_percent'),
      },
      step: 1,
      isLoading: false,
      isAddArea: false,
      isLoadSearch: false,
      isLoadCustomer: false,
      isLoadLatestBooking: false,
      isCreateBooking: false,
      searchDialog: false,
      isCancelConfirm: false,
      bookingAreaProductsDialog: false,
      bookingChannelDialog: false,
      isInvoiceDialog: false,
      isChannel: false,
      isPrintDialog: false,
      bookingAreaProductsIndex: "",
      bookingChannelIndex: "",
      addContractDialog: false,
      isDialogAccountingProduct: false,
      currentInvoiceId: null,
      currentBookingId: null,
      currentContractData: null,
      currentAreasContract: [],
      isEdit: false,
      isNotCheckInArea: false,
      editContractDialog: false,
      invoiceContract: null,
      isBillingSelect: false,
      form: {
        bookingId: undefined,
        data: [],
        stallType: "",
        customer: undefined,
        businessName: "",
        bookingChannel: undefined,
        note: "",
      },
      currencyCode: this.$globalCurrencyCode,
      headerBilling: [
        {
          text: this.$t('list'),
          value: "accountingProduct",
          width: "300px"
        },
        {
          text: this.$t('product.quantity'),
          value: "number",
          width: "120px",
          align: "right"
        },
        {
          text: this.$t('accounting_product.unit'),
          value: "accountingProduct.unit",
          width: "100px"
        },
        {
          text: this.$t('product.unit_price'),
          value: "cost",
          width: "200px",
          align: "right"
        },
        {
          text: this.$t('product.total_price'),
          value: "sum",
          width: "300px",
          align: "right"
        }
      ],
      headerBillingMonthly: [
        {
          text: this.$t('list'),
          value: "accountingProduct.name",
          width: "200px"
        },
        {
          text: this.$t('area.space'),
          value: "area.name",
          width: "100px"
        },
        {
          text: this.$t('product.quantity'),
          value: "number",
          width: "120px",
          align: "right"
        },
        {
          text: this.$t('accounting_product.unit'),
          value: "accountingProduct.unit",
          width: "100px"
        },
        {
          text: this.$t('product.unit_price'),
          value: "cost",
          width: "200px",
          align: "right"
        },
        {
          text: this.$t('product.total_price'),
          value: "sum",
          width: "300px",
          align: "right"
        }
      ],
      stallTypeLabel: {
        regularly: this.$t('contact.stall_type.regularly'),
        temporary: this.$t('contact.stall_type.temporary')
      },
      taxWithheldOptions: [
        {
          name: this.$t('no'),
          value: 0
        },
        {
          name: "0.75%",
          value: 0.75
        },
        {
          name: "1%",
          value: 1
        },
        {
          name: "1.5%",
          value: 1.5
        },
        {
          name: "2%",
          value: 2
        },
        {
          name: "3%",
          value: 3
        },
        {
          name: "5%",
          value: 5
        },
        {
          name: "10%",
          value: 10
        },
        {
          name: "15%",
          value: 15
        }
      ],
      billListHeaders: [
        { value: "date", text: this.$t('date') },
        { text: this.$t('invoice.installment_due_date'), value: "dueDate", },
        { text: this.$t('type'), value: "documentTypeString", align: "center", },
        { value: "documentId", text: this.$t('number') },
        { value: "customerData.name", text: this.$t('customer.title') },
        { value: "totalValue", text: this.$t('market.total_value'), align: "right" },
        { value: "totalUnpaidValue", text: this.$t('invoice.remaining_amount'), align: "right" },
        { value: "status", text: this.$t('status'), align: "center", },
      ],
      latestBookings: [],
      latestBooking: null,
      reBookingRes: [],
      isLoadReBooking: false,
      loadReBookingProgress: 0,
      repeatBookingStatusDialog: false,
      addBookingsDialog: false,
      formAddBookings: {},
      filterAreas: [],
      filterArea: 'All',
      filterDaysOfWeeks: [],
      filterDaysOfWeek: [],
      isSelectAll: false,
      unSelectAll: false,
      loopData: {
        all: []
      },
      viewType: "table",
      allAvailableAreas: [],
      searchArea: "",
      areaTable: {
        headers: [
          {
            text: this.$t('area.area_name'),
            value: "name",
            width: "80%"
          },
          {
            text: this.$t('area.area_size_square_meter'),
            value: "size"
          }
        ],
      },
      formAreaBookings: [],
      isLoadBillingSettings: false,
      isPreviewRepeatDialog: false,
      isRemoveAreaBookingDialog: false,
      eventAvailableAreas: {
        all: [],
        months: {}
      },
      billingSettings: [],
      unAvailableAreas: [],
      paymentMethods : {
        1: this.$t('payment.methods.1'),
        2: this.$t('payment.methods.2'),
        3: this.$t('payment.methods.3'),
        4: this.$t('payment.methods.4'),
        5: this.$t('payment.methods.5'),
        6: this.$t('payment.methods.6'),
        7: this.$t('payment.methods.7'),
        8: this.$t('payment.methods.8')
      },
      project: null,
      market: null,
    };
  },
  props: {
    value: Boolean,
    type: String,
    marketId: String,
    projectId: String,
    areaId: String,
    booking: Object,
    areaBookings: Array, //areaBookings is Array<Object>:[{area<Area>,startDate<Date>,endDate<Date>,products<Array>}]
    isMainLoading: {
      default: false,
      type: Boolean
    },
    startDateReq: Date,
    endDateReq: Date
  },
  computed: {
    ...mapState({
      accountingProducts: state => state.accountingProducts.accountingProducts
    }),
    ...mapGetters({
      getProductNameOnly: "product/getProductNameOnly",
      getBookingChannelNameOnly: "bookingChannel/getBookingChannelNameOnly",
      getProjectId: 'markets/getProjectId',
      getAreas: "area/getAreas",
      getProducts: "product/getProducts",
      getAdminByMarketId: "admin/getByMarketId",
      getEmployeeByMarketId: "employee/getByMarketId",
    }),
    bookingDialog: {
      get() {
        return this.value;
      },
      set(value) {
        if (!value) this.clearData();
        this.$emit("input", value);
      }
    },
    statusBtn() {
      let btn = {
        edit: false,
        cancel: false,
        contract: false
      };
      if (this.booking && this.booking.areaBookings) {
        let hasCheckedIn = this.booking.areaBookings.filter(
          item => item.checkedInDate
        );
        let expEndDate = this.booking.areaBookings.filter(
          item =>
            item.endDate &&
            this.$moment(item.endDate.iso).isBefore(this.$moment())
        );
        let startDateNow =
          this.booking.areaBooking &&
          this.booking.areaBooking.startDate &&
          this.$moment(this.booking.areaBooking.startDate.iso).isAfter(
            this.$moment()
          );
        if (
          hasCheckedIn &&
          hasCheckedIn.length > 0
          // ||
          // (expEndDate && expEndDate.length > 0)
        ) {
          btn.edit = false;
          btn.cancel = true;
          btn.contract = true;
        } else {
          btn.edit = false;
          btn.cancel = false;
          // if (startDateNow) {
          // btn.contract = true;
          // } else {
          btn.contract = false;
          // }
        }
      }

      return btn;
    },
    currentType() {
      let isDaily = false;
      let isMonthly = false;
      if (this.booking) {
        if (this.booking.type == "daily") isDaily = true;
        if (this.booking.type == "monthly") isMonthly = true;
      } else {
        if (this.form.type == "daily") isDaily = true;
        if (this.form.type == "monthly") isMonthly = true;
      }
      return { isDaily, isMonthly };
    },
    isAreasOccupied() {
      if (this.booking && this.booking.areaBookings && this.booking.areaBookings.filter(d => d.area.isOccupied).length) {
        return true
      }
    },
    isDuplicateItemData() {
      for (let data of this.formAreaBookings || []) {
        if (data.invoice?.items?.find(d => this.isDuplicateItem(d, data.invoice?.items))) {
          return true
          break
        }
      }
    },
    currentVacancyAreas() {
      let currentVacancyAreas = []
      if (this.isEdit) {
        return this.form.selectedAreas
      } else {
        let allAreas = []
        if (this.form.subType == "daily-repeat") {
          allAreas = this.getAreas
        } else {
          allAreas = this.allAvailableAreas
        }
        if (this.viewType == "table") {
          if (this.filterArea == 'All') {
            currentVacancyAreas = allAreas
          } else if (this.filterArea == 'isAvailable') {
            currentVacancyAreas = allAreas.filter(a => a.statusBooking && a.statusBooking.isAvailable)
          } else if (this.filterArea == 'isSuspend') {
            currentVacancyAreas = allAreas.filter(a => a.statusBooking && a.statusBooking.isSuspend)
          } else if (this.filterArea == 'isOutContract') {
            currentVacancyAreas = allAreas.filter(a => a.statusBooking && a.statusBooking.isOutContract)
          } else if (this.filterArea == 'isInContract') {
            currentVacancyAreas = allAreas.filter(a => a.statusBooking && a.statusBooking.isInContract)
          } else {
            this.filterArea = 'All'
            currentVacancyAreas = allAreas
          } 
        } else {
          currentVacancyAreas = allAreas
        }
        return currentVacancyAreas
      }
    },
    typeColor() {
      if (this.currentType.isDaily) {
        return {
          textClass: "daily-color",
          color: "primary"
        }
      } else {
        return {
          textClass: "monthly-color",
          color: "info"
        }
      }
    },
    allInvoiceItems() {
      let items = []
      for (let formAreaBooking of this.formAreaBookings) {
        if (formAreaBooking.invoice && formAreaBooking.invoice.items) {
          items = [...items, ...formAreaBooking.invoice.items]
        }
      }
      return items
    },
    admin() {
      return this.getAdminByMarketId(this.marketId);
    },
    employee() {
      return this.getEmployeeByMarketId(this.marketId);
    },
    enableAddAccountingProduct(){
      if (this.admin || this.employee && this.employee.enableAddAccountingProduct) {
        return true
      }
    },
    accountingProductOptions() {
      let _accountingProducts = this.accountingProducts?.map(d => {
        return {
          isAddProduct: false,
          name: `${d.name}`,
          objectId: d.objectId,
          obj: d
        };
      }) || []
      if (this.enableAddAccountingProduct) _accountingProducts.push({ isAddProduct: true })
      return _accountingProducts
    },
  },
  watch: {
    bookingDialog: {
      handler(value) {
        if (value) {
          this.initData();
        }
      },
      immediate: true
    },
  },
  created() {
    if (this.admin) {
      this.project = this.admin.project;
      this.market = this.admin.market;
    }
    if (this.employee) {
      this.project = this.employee.project;
      this.market = this.employee.market;
    }
  },
  methods: {
    ...mapActions({
      getCustomer: 'customer/getCustomer',
      getBooking: 'booking/getBooking',
      getBookingByCustomerLimit: 'booking/getBookingByCustomerLimit',
      getAccountingProducts: 'accountingProducts/getAccountingProducts',
      getDailyBillingSettingsByAreas: 'dailyBillingSetting/getDailyBillingSettingsByAreas',
      getBillingSettingsByAreas: 'billingSetting/getBillingSettingsByAreas',
      getAvailableAreas: 'area/getAvailableAreas',
      getAvailableArea: 'area/getAvailableArea',
      createInvoice: 'invoice/createBookingInvoice',
      sendInvoice: 'invoice/sendInvoice',
      sendInvoices: 'invoice/sendInvoices',
      createBooking: 'booking/createBooking',
      createBookingArea: 'areaBooking/createAreaBooking',
      updateBooking: 'booking/editBooking',
      updateAreaBooking: 'areaBooking/editAreaBooking',
      cancelAreaBooking: 'areaBooking/cancelAreaBooking',
      cancelBooking: 'booking/cancelBooking',
      getBookingChannels: 'bookingChannel/getBookingChannels',
      checkInAreaBooking: 'areaBooking/checkInAreaBooking',
      getProductsFn: 'product/getProducts',
      checkOutAreaBooking: 'areaBooking/checkOutAreaBooking',
      checkInMonthlyBookingFirst: 'booking/checkInMonthlyBookingFirst',
    }),
    setFormDate(formAreaBookings) {
      let startDate
      let endDate
      let maxDate
      let minDate
      for (let areaBooking of formAreaBookings) {
        if (this.currentType.isDaily) {
          startDate = this.$moment(`${areaBooking.startDate} ${areaBooking.startTime}`, "YYYY-MM-DD HH:mm");
          endDate = this.$moment(`${areaBooking.endDate} ${areaBooking.endTime}`, "YYYY-MM-DD HH:mm");
        } else {
          startDate = this.$moment(areaBooking.startDate, "YYYY-MM-DD");
          endDate = this.$moment(areaBooking.endDate, "YYYY-MM-DD");
        }
        if (!maxDate || (maxDate < endDate)) maxDate = endDate
        if (!minDate || (minDate > startDate)) minDate = startDate
      }
      if (minDate) this.form.startDate = minDate.format("YYYY-MM-DD");
      if (maxDate) this.form.endDate = maxDate.format("YYYY-MM-DD");
      if (minDate) this.form.startTime = minDate.format("HH:mm");
      if (maxDate) this.form.endTime = maxDate.format("HH:mm");
      this.calContractDays()
      return { startDate: minDate?.toDate(), endDate: maxDate?.toDate() }
    },
    async initData() {
      this.isLoading = true;
      await this.getAccountingProducts(this.projectId);
      this.clearData();
      this.form.isVatInclusive = this.project.isVatInclusive;
      if (this.booking) {
        let booking;
        booking = await this.getBooking(this.booking.objectId);
        if (booking) await this.$emit("setBooking", booking);
        this.form.bookingId = booking.objectId;
        this.form.customer = new Customer(booking.customer);
        this.form.businessName = booking.businessName;
        this.form.bookingChannel = booking.bookingChannel;
        this.form.note = booking.note;
        this.form.stallType = booking.stallType;
        this.form.data = [];
        this.form.market = booking.market;
        this.form.project = booking.project;
        this.form.contract = booking.contract;
        this.form.status = booking.status;
        this.form.selectedAreas = []
        this.form.subType = booking.subType || booking.type;
        this.form.invoices = booking.invoices
        // this.form.subType = "daily-repeat";

        await this.loadContractInvoice()
        let startDate, endDate;
        if (this.currentType.isDaily) {
          if (this.form.subType == "daily-repeat") {
            this.form.loopType = booking.loopType
            this.form.loopDays = booking.loopDays
            this.form.loopDate = booking.loopDate
            this.form.loopWeekDays = booking.loopWeekDays
            this.loopData = {
              all: []
            }
            for (let date of booking.loopDays) {
              let mm = this.$moment(date)
              if (!this.loopData[mm.format("YYYY-MM")]) this.loopData[mm.format("YYYY-MM")] = []
              this.loopData[mm.format("YYYY-MM")].push(mm.format("YYYY-MM-DD"))
              this.loopData.all.push(mm.format("YYYY-MM-DD"))
            }
          }

          for (let areaBooking of booking.areaBookings) {
            if (!this.form.selectedAreas.find(a => a.objectId == areaBooking.area.objectId)) {
              this.form.selectedAreas.push(areaBooking.area)
            }
            startDate = this.$moment(areaBooking.startDate.iso)
            endDate = this.$moment(areaBooking.endDate.iso)


            this.formAreaBookings.push({
              id: areaBooking.objectId,
              startDate: startDate ? startDate.format("YYYY-MM-DD") : "",
              startTime: startDate ? startDate.format("HH:mm") : "",
              endDate: endDate ? endDate.format("YYYY-MM-DD") : "",
              endTime: endDate ? endDate.format("HH:mm") : "",
              products: areaBooking.products,
              area: areaBooking.area,
              isExpand: false,
              invoice: {
                items: []
              }
            });
          }
        } else if (this.currentType.isMonthly) {
          for (let areaBooking of booking.areaBookings) {
            if (!this.form.selectedAreas.find(a => a.objectId == areaBooking.area.objectId)) {
              this.form.selectedAreas.push(areaBooking.area)
            }
            startDate = this.$moment(areaBooking.startDate.iso).format("YYYY-MM-DD");
            endDate = this.$moment(areaBooking.endDate.iso).format("YYYY-MM-DD");
            this.formAreaBookings.push({
              id: areaBooking.objectId,
              startDate,
              endDate, 
              products: areaBooking.products,
              area: areaBooking.area,
              isExpand: false,
              invoice: {
                items: []
              }
            })
          }
        }
        this.setFormDate(this.formAreaBookings)
      } else {
        let startDateReq = this.startDateReq
        let endDateReq = this.endDateReq
        if (this.areaBookings && this.areaBookings.length) {
          startDateReq = this.areaBookings[0].startDate
          endDateReq = this.areaBookings[0].endDate
        }

        this.form.startDate = startDateReq ? this.$moment(startDateReq).format("YYYY-MM-DD") : this.$moment().format("YYYY-MM-DD");
        this.form.startTime = "08:00";
        this.form.endTime = "20:00";

        if (this.type == "daily") {
          this.form.type = "daily";
          this.form.subType = "daily";
          this.form.endDate = endDateReq ? this.$moment(endDateReq).format("YYYY-MM-DD") : this.$moment().format("YYYY-MM-DD");
        } else if (this.type == "monthly") {
          this.form.type = "monthly";
          this.form.subType = "monthly";
          this.form.endDate = endDateReq ? this.$moment(endDateReq).format("YYYY-MM-DD") : this.$moment().add(1, "months").format("YYYY-MM-DD");
          this.calContractDays()
        }
        await this.searchAllAvailableAreas();
        if (this.areaId) this.form.selectedAreas = this.currentVacancyAreas.filter(a => a.id == this.areaId);
        if (this.areaBookings && this.areaBookings.length) {
          for (let { area } of this.areaBookings) {
            let vacancyArea = this.currentVacancyAreas.find(a => a.id == area.objectId)
            this.form.selectedAreas.push(vacancyArea)
          }
        }
      }
      this.getProductsFn({ projectId: this.projectId ? this.projectId : this.getProjectId });
      this.loadBookingChannel();
      this.isSelectAll = false
      this.unSelectAll = false
      this.isLoading = false;
    },
    calContractDays() {
      this.form.contractDays = this.diffDays(this.form)
    },
    clearData() {
      this.step = 1;
      this.filterAreas = []
      this.loopData = {
        all: []
      },
      this.searchAreas = ""
      this.form = {
        bookingId: undefined,
        data: [],
        stallType: "",
        customer: undefined,
        businessName: "",
        bookingChannel: undefined,
        products: [],
        note: "",
        isStartDate: false,
        isEndDate: false,
        startDate: this.$moment().format("YYYY-MM-DD"),
        endDate: this.$moment().format("YYYY-MM-DD"),
        startTime: "08:00",
        endTime: "20:00",
        tempStartDate: "",
        tempEndDate: "",
        tempStartTime: "",
        tempEndTime: "",
        type: "monthly",
        subType: "monthly",
        contractDays: this.diffDays({
          startDate: this.$moment().format("YYYY-MM-DD"),
          endDate: this.$moment().format("YYYY-MM-DD"),
          startTime: "08:00",
          endTime: "20:00" 
        }),
        loopType: null,
        loopDays: [],
        loopWeekDays: [],
        loopDate: null,
        selectedAreas: [],
        isAddItemAll: false
      };
      this.currentContractData = null;
      this.isEdit = false;
      this.formAreaBookings = []
      if (this.$refs.formStep1) this.$refs.formStep1.resetValidation();
    },
    async selectCustomer(value) {
      if (value) {
        this.isLoadCustomer = true;
        this.searchDialog = false;
        this.form.customer = await this.getCustomer({
          id: value.objectId
        });
        if (this.form.customer.type != "company" || this.market.disableWht) {
          for (const data of this.form.data) {
            for (let item of data.items) {
              item.whtPercent = 0;
            }
          }
        }
        this.isLoadCustomer = false;
        if (this.form.customer) this.loadBookingByCustomerLimit()
      } else {
        this.form.customer = null
        this.latestBookings = []
        this.latestBooking = null
      }
    },
    async loadBookingByCustomerLimit() {
      try {
        this.isLoadLatestBooking = true
        this.latestBookings = await this.getBookingByCustomerLimit({
          marketId: this.marketId,
          customerId: this.form?.customer ? this.form.customer.objectId : '',
          bookingType: "all",
          // areaIds,
          limit: 8
        })
        this.isLoadLatestBooking = false
      } catch (error) {
        this.$toast.show({
          content: this.$helper.ShowToastCatchError(error),
          color: "error"
        });
        console.log('Error load latest bookings,', error)
        this.latestBookings = []
        this.latestBooking = null
        this.isLoadLatestBooking = false
      }
    },
    async getBillingSettingsByAreasFn(areas) {
      let billingSetting;
      if (this.currentType.isDaily) {
        billingSetting = await this.getDailyBillingSettingsByAreas({ areaIds: areas, currencyCode: this.currencyCode });
      } else if (this.currentType.isMonthly) {
        billingSetting = await this.getBillingSettingsByAreas({ areaIds: areas, currencyCode: this.currencyCode });
      }
      return billingSetting;
    },
    async changeCurrencyCode(currencyCode) {
      this.currencyCode = currencyCode;
      if (this.form.selectedAreas?.length) {
        const areaIds = this.form.selectedAreas.map(area => area.objectId);
        const billingSettings = await this.getBillingSettingsByAreasFn(areaIds);
        for (const formAreaBooking of this.formAreaBookings) {
          await this.inputSelectArea(formAreaBooking, billingSettings);
        }
      }
    },
    async inputSelectArea(formAreaBooking, billingSettings = []) {
      let formInvoice = formAreaBooking.invoice
      this.isAddArea = true;
      if (this.currentType.isDaily && formAreaBooking?.area?.objectId) {
        let area = formAreaBooking.area
        billingSettings = billingSettings.filter(x => x.area.objectId == area.objectId);
        formInvoice.items = [];
        let numberDays = this.diffDays(formAreaBooking);
        for (const billingSetting of billingSettings) {
          let originalDiscountPerUnit = 0
          if (billingSetting.discountType == 1) {
            originalDiscountPerUnit = billingSetting.discount || 0
          } else {
            originalDiscountPerUnit = (billingSetting.cost * (billingSetting.discount || 0) / 100)
          }
          let areaSize = billingSetting?.area?.size ? parseFloat(billingSetting.area.size) : 0
          let number = billingSetting.type == "booking" ? 1 : billingSetting.type == "daily" ? numberDays : billingSetting.type == "daily_square_metre" ? areaSize * numberDays : billingSetting.type == "booking_square_metre" ? areaSize : 1
          formInvoice.items.push({
            area: billingSetting.area,
            unit: `${billingSetting.type == "daily_square_metre" || billingSetting.type == "booking_square_metre" ? this.$t('area.square_meter') : ''}${billingSetting.accountingProduct.unit}`,
            sellVatType: billingSetting.accountingProduct.sellVatType,
            accountingProduct: billingSetting.accountingProduct,
            accountingProductId: billingSetting.accountingProduct.objectId,
            whtPercent:
              this.form.customer &&
                this.form.customer.type == "company" &&
                !this.market.disableWht
                ? billingSetting.accountingProduct.whtPercent || 0
                : 0,
            originalPricePerUnit: billingSetting.cost,
            number,
            totalOriginalValue: (billingSetting.cost - originalDiscountPerUnit) * number,
            billingSettingType: billingSetting.type,
            dailyBillingSetting: billingSetting,
            discountType: billingSetting.discountType || 1,
            discountPerUnit: billingSetting.discount || 0,
            type: billingSetting.accountingProduct.type,
          });
        }
        // if (isFormAddBookings) this.dateFormAddBookingChange(areaSize)
      }
      this.isAddArea = false;
    },
    clickBookingAreaProduct(index) {
      this.bookingAreaProductsIndex = index;
      this.bookingAreaProductsDialog = true;
    },
    clickBookingChannel() {
      this.bookingChannelDialog = true;
    },
    saveProduct(products) {
      if (!this.addBookingsDialog)
        this.form.data[this.bookingAreaProductsIndex].products = products;
      else
        this.formAddBookings.products = products;
      this.bookingAreaProductsDialog = false;
      this.bookingAreaProductsIndex = "";
    },
    saveBookingChannel(bookingChannel) {
      this.form.bookingChannel = bookingChannel;
      this.bookingChannelDialog = false;
    },
    checkHasInvoice(currencyCode) {
      return this.form.invoices && this.form.invoices.length && this.form.invoices.some(invoice => invoice.currencyCode == currencyCode)
    },
    sumField(data, key, key2, currencyCode) {
      if (!data || !data.length) return 0;
      const groupedData = data.reduce((acc, item) => {
        const code = item.currencyCode || this.globalCurrencyCode;
        if (!acc[code]) acc[code] = [];
        acc[code].push(item);
        return acc;
      }, {});

      if (currencyCode) {
        const items = groupedData[currencyCode] || [];
        if (key2) {
          return items.reduce((a, b) => a + (b[key] * b[key2] || 0), 0);
        }
        return items.reduce((a, b) => a + (b[key] || 0), 0);
      }
      if (key2) {
        return data.reduce((a, b) => a + (b[key] * b[key2] || 0), 0);
      }
      return data.reduce((a, b) => a + (b[key] || 0), 0);
    },
    sumAll(items) {
      let sum = 0;
      if (items && items.length) {
        sum += this.sumField(items, "originalPricePerUnit", "number");
      }
      return sum;
    },
    
    dateFormat(date, format = "YYYY-MM-DD", outFormat = "DD MMM YYYY HH:mm") {
      let res = "";
      if (date) {
        res = this.$moment(date, format).format(outFormat);
      }
      return res;
    },
    fullName(customer) {
      let res = "";
      if (customer) {
        res = `${customer.firstName} ${customer.lastName}`;
      }
      return res;
    },
    diffDays(item, format = this.currentType.isDaily ? "YYYY-MM-DD HH:mm" : "YYYY-MM-DD") {
      let days = 0;
      let minutes = 0;
      if (item.startDate && item.startTime && item.endDate && item.endTime && this.currentType.isDaily) {
        minutes =
          this.$moment(`${item.endDate} ${item.endTime}`, format).diff(
            this.$moment(`${item.startDate} ${item.startTime}`, format),
            "minutes"
          ) || 0;
      } else if (item.startDate && item.endDate && this.currentType.isMonthly) {
        minutes =
          this.$moment(`${item.endDate}`, format).endOf("day").diff(
            this.$moment(`${item.startDate}`, format).startOf('day'),
            "minutes"
          ) || 0;
      }
      days = Math.ceil(minutes / (24 * 60));
      return days;
    },
    diffDaysIso(item) {
      let days = 0;
      let minutes = 0;
      if (
        item.startDate &&
        item.startDate.iso &&
        item.endDate &&
        item.endDate.iso
      ) {
        minutes =
          this.$moment(item.endDate.iso).diff(
            this.$moment(item.startDate.iso),
            "minutes"
          ) || 0;
        days = Math.ceil(minutes / (24 * 60));
      }
      return days;
    },
    currentAreas(areas, areaSelect) {
      let res = [];
      for (const area of areas) {
        let isBreak = false;
        for (const areaIn of this.form.data) {
          if (!areaIn.area) break;
          if (
            areaIn.area.objectId == area.objectId &&
            (!areaSelect || (areaSelect && area.objectId != areaSelect.objectId))
          ) {
            isBreak = true;
            break;
          }
        }
        if (!isBreak) {
          res.push(area);
        }
      }
      return res;
    },
    checkHasArea() {
      let res = false;
      if (
        this.form.data &&
        ((this.currentType.isDaily &&
          this.form.data.filter(item => item.area && item.area.objectId)
            .length != this.form.data.length) ||
          (this.currentType.isMonthly &&
            (!this.form.data[0] ||
              !this.form.data[0].area ||
              this.form.data[0].area.length == 0)))
      )
        res = true;
      return res;
    },
    async saveBooking() {
      try {
        if (!this.form.businessName) {
          this.$toast.show({
            content: this.$t('validate.error_save_data_info_not_complete'),
            color: "error"
          });
          this.step = 1;
          this.$refs.formStep1.validate()
          return false
        }
  
        this.isCreateBooking = true;
        this.isLoading = true;
        let booking;
        if (!this.isEdit) {
          let postData = {
            marketId: this.marketId,
            bookingChannelId: this.form.bookingChannel
              ? this.form.bookingChannel.objectId
              : "",
            type: this.form.type,
            customerId: this.form?.customer ? this.form.customer.objectId : "",
            businessName: this.form.businessName,
            stallType: this.form.stallType || "",
            areaBookingIds: [],
            invoiceIds: [],
            note: this.form.note,
            subType: this.form.subType,
          }
          if (this.form.subType == "daily-repeat") {
            postData.loopType = this.form.loopType
            postData.loopDays = this.loopData.all
            postData.loopDate = this.form.loopDate
            if (this.form.loopType == "everyweek") {
              postData.loopWeekDays = this.form.loopWeekDays
            }
          }
          booking = await this.createBooking(postData);
        } else {
          booking = this.booking;
        }
  
        let invoices = []
        let areaBookings = [];
        let formatTime = "YYYY-MM-DD HH:mm";
        for (let areaBooking of this.formAreaBookings) {
          if (this.currentType.isDaily) {
            let formDataIn = {
              id: areaBooking.id,
              bookingId: booking.objectId,
              startDate: this.$moment(
                `${areaBooking.startDate} ${areaBooking.startTime}`,
                formatTime
              ).toDate(),
              endDate: this.$moment(
                `${areaBooking.endDate} ${areaBooking.endTime}`,
                formatTime
              ).toDate(),
              areaId: areaBooking.area.objectId,
              products: areaBooking.products.map(item => item.objectId) || []
            };
  
            let _areaBooking
            if (formDataIn.id) {
              _areaBooking = await this.updateAreaBooking(formDataIn);
            } else {
              _areaBooking = await this.createBookingArea(formDataIn);
            }
            areaBookings.push(_areaBooking);
  
            if (this.sumAll(areaBooking.invoice.items) > 0) {
              let invoiceItems = [];
              for (const item of areaBooking.invoice.items) {
                invoiceItems.push(
                  new DocumentItem({
                    accountingProduct: item.accountingProduct,
                    dailyBillingSetting: item.dailyBillingSetting,
                    area: item.area,
                    name: item.accountingProduct.name,
                    originalPricePerUnit: item.originalPricePerUnit,
                    quantity: item.number,
                    whtPercent: item.whtPercent,
                    sellVatType: item.sellVatType,
                    unit: item.unit,
                    discountType: item.discountType,
                    discountPerUnit: item.discountPerUnit,
                    type: item.type
                  })
                );
              }
              let invoice = await this.createInvoice({
                marketId: this.marketId,
                bookingId: booking.objectId,
                type: "7",
                items: invoiceItems,
                date: this.$moment().startOf("day").toDate(),
                dueDate: this.$moment(`${areaBooking.endDate} ${areaBooking.endTime}`, formatTime).endOf("day").toDate(),
                customerData: Customer.getBillingDataByCustomer(this.form.customer),
                isVatInclusive: this.form.isVatInclusive,
                areaBookingId: _areaBooking.objectId,
                currencyCode: this.currencyCode
              });
  
              if (invoice.objectId) {
                invoices.push(invoice)
              }
  
            }
          } else if (this.currentType.isMonthly) {
            let formDataIn = {
              id: areaBooking.id,
              bookingId: booking.objectId,
              startDate: this.$moment(this.form.startDate, "YYYY-MM-DD")
                .startOf("day")
                .toDate(),
              endDate: this.$moment(this.form.endDate, "YYYY-MM-DD")
                .endOf("day")
                .toDate(),
              areaId: areaBooking.area.objectId,
              products: areaBooking.products.map(item => item.objectId) || []
            };
  
            let _areaBooking
            if (formDataIn.id) {
              _areaBooking = await this.updateAreaBooking(formDataIn);
            } else {
              _areaBooking = await this.createBookingArea(formDataIn);
            }
            areaBookings.push(_areaBooking);
          }
        }
        await this.updateBooking({
          id: booking.objectId,
          areaBookingIds: areaBookings.map(item => item.objectId),
          invoiceIds: !this.isEdit ? invoices.map(item => item.objectId) : undefined,
          bookingChannelId: this.form.bookingChannel
            ? this.form.bookingChannel.objectId
            : "",
          businessName: this.form.businessName,
          stallType: this.form.stallType,
          note: this.form.note
        });

        // send invoices
        if (invoices.length) {
          await this.sendInvoices({
            ids: invoices.map(item => item.objectId),
            bookingId: booking.objectId
          });
        }

        if (booking) await this.$emit("createBookingSuccess", booking);
        else if (this.booking) this.$emit("createBookingSuccess", this.booking);
        else this.$emit("createBookingSuccess");
        this.$eventBus.$emit("updateAreaPlan");
        this.clearData();
        this.initData();
      } catch (error) {
        this.$toast.show({
          content: this.$t('error'),
          color: "error"
        })
      }
      this.isLoading = false;
      this.isCreateBooking = false;
    },
    async cancelBookingFn() {
      this.isLoading = true;
      if (this.booking && this.booking.objectId) {
        try {
          await this.cancelBooking(this.booking.objectId);
        } catch (error) {
          this.$toast.show({
            content: this.$helper.ShowToastCatchError(error),
            color: "error"
          });
        }
      }
      if (this.booking) this.$emit("createBookingSuccess", this.booking);
      else this.$emit("createBookingSuccess");
      this.$eventBus.$emit("updateAreaPlan");
      this.isLoading = false;
    },
    openInvoice(invoice) {
      this.currentInvoiceId = invoice.objectId;
      this.currentBookingId = this.booking.objectId;
      this.isInvoiceDialog = true;
    },
    async onSaveSuccess(res) {
      if (!res || (res && !res.isUnSendSuccess))
        this.$emit("createBookingSuccess", this.booking);
      await this.initData()
    },
    async loadBookingChannel() {
      await this.getBookingChannels(this.$route.params.projectId ? this.$route.params.projectId : this.getProjectId);
    },
    async checkInArea(areaBooking) {
      this.isLoading = true;
      try {
        let checkInData = await this.checkInAreaBooking({ id: areaBooking.objectId });
      } catch (error) {
        this.$toast.show({
          content: this.$t(this.$helper.ShowToastCatchError(error)),
          color: "error"
        });
      }
      this.$emit("createBookingSuccess", areaBooking.booking);
      this.$eventBus.$emit("updateAreaPlan");
      this.isLoading = false;
    },
    async checkOutArea(areaBooking) {
      this.isLoading = true;
      try {
        let checkOutData = await this.checkOutAreaBooking({ id: areaBooking.objectId });
      } catch (error) {
        this.$toast.show({
          content: this.$helper.ShowToastCatchError(error),
          color: "error"
        });
      }
      this.$emit("createBookingSuccess", areaBooking.booking);
      this.$eventBus.$emit("updateAreaPlan");
      this.isLoading = false;
    },
    showCheckInBtn(areaBooking) {
      let show = false;
      if (areaBooking && !areaBooking.checkedInDate) {
        show = true;
      }
      return show;
    },
    addInvoice(booking) {
      this.currentContractData = {
        objectId: null,
        customer: booking.customer,
        billingData: Customer.getBillingDataByCustomer(booking.customer)
      };
      this.currentInvoiceId = null;
      this.currentBookingId = booking.objectId;
      this.isInvoiceDialog = true;
    },
    clickEdit(isEdit) {
      this.isEdit = isEdit;
    },
    async onCheckinMonthlyBooking() {
      try {
        await this.checkInMonthlyBookingFirst(this.booking.objectId);
        this.isNotCheckInArea = false;
        this.addContractDialog = true;
        if (this.form?.data?.length && this.form.data[0]?.area?.length) {
          this.currentAreasContract = [];
          this.form.data[0].area.map(item =>
            this.currentAreasContract.push({ area: item })
          ) || [];
        }
      } catch (error) {
        this.$toast.show({
          content: this.$helper.ShowToastCatchError(error),
          color: "error"
        });
      }
    },
    onCreateContract() {
      this.isNotCheckInArea = true;
      this.addContractDialog = true;
    },
    async contractSuccess() {
      this.isLoading = true
      try {
        if (this.isNotCheckInArea) {
          for (let areaBooking of this.booking.areaBookings) {
            if (this.$moment() >= this.$moment(areaBooking.startDate.iso)) {
              let area = areaBooking.area
              if (!area.contract && !area.areaBooking) {
                await this.checkInAreaBooking({ id: areaBooking.objectId });
              }
            }
          }
        }
        await this.$emit("createBookingSuccess", this.booking);
        await this.initData();
        this.isLoading = false
      } catch (error) {
        this.$toast.show({
          content: this.$helper.ShowToastCatchError(error),
          color: "error"
        });
        this.isLoading = false
      }

    },
    async onUpdateContract() {
      this.initData();
    },
    addProduct() {
      this.isDialogAccountingProduct = true;
    },
    async loadContractInvoice() {
      this.invoiceContract = null
      if (this.form.contract && this.form.status != "success") {
        this.invoiceContract = await Invoice.getInvoicesByContract({
          marketId: this.form.market.objectId,
          projectId: this.form.project.objectId,
          contractId: this.form.contract.objectId
        })
      }
    },
    chooseItem(item, index, items) {
      let accountingProduct = item.obj;
      items.area = undefined;
      items.unit = accountingProduct.unit;
      items.sellVatType = accountingProduct.sellVatType;
      items.accountingProduct = accountingProduct;
      items.accountingProductId = accountingProduct.objectId;
      items.whtPercent = this.form.customer &&
        this.form.customer.type == "company" &&
        !this.market.disableWht
        ? accountingProduct.whtPercent || 0
        : 0;
      items.type = accountingProduct.type;
      items.originalPricePerUnit = 0;
      items.number = 1;
      items.totalOriginalValue = 0;
      items.discountType = 1;
      items.discountPerUnit = 0;
    },
    addItem(index, items = this.formAreaBookings[index].invoice.items) {
      if (items)
        items.push({
          area: undefined,
          unit: "",
          sellVatType: "",
          accountingProduct: undefined,
          accountingProductId: "",
          whtPercent: 0,
          originalPricePerUnit: 0,
          number: 1,
          totalOriginalValue: 0,
          discountType: 1,
          discountPerUnit: 0
        });
    },
    changeTotalOriginalValue(index, indexItem, items = this.form.data[index]?.items, isOriginalPricePerUnitChange = false) {
      if (items && items[indexItem]) {
        items[indexItem].number = parseFloat(items[indexItem].number);
        items[indexItem].originalPricePerUnit = parseFloat(items[indexItem].originalPricePerUnit);
        items[indexItem].totalOriginalValue = parseFloat(items[indexItem].totalOriginalValue);
        items[indexItem].discountPerUnit = parseFloat(items[indexItem].discountPerUnit);

        let originalPricePerUnit = 0

        if (!isOriginalPricePerUnitChange) {
          originalPricePerUnit = items[indexItem].totalOriginalValue / items[indexItem].number
        } else {
          originalPricePerUnit = items[indexItem].originalPricePerUnit
        }

        let originalDiscountPerUnit = this.originalDiscountPerUnit(items[indexItem])

        if (items[indexItem].type == "discount") {
          if (!isOriginalPricePerUnitChange) {
            items[indexItem].discountPerUnit = (items[indexItem].totalOriginalValue / items[indexItem].number) * -1
          } else {
            items[indexItem].totalOriginalValue = ((originalPricePerUnit - items[indexItem].discountPerUnit) * items[indexItem].number)
          }
        } else {
          if (!isOriginalPricePerUnitChange) {
            items[indexItem].originalPricePerUnit = (items[indexItem].totalOriginalValue / items[indexItem].number) + originalDiscountPerUnit
          } else {
            items[indexItem].totalOriginalValue = (items[indexItem].originalPricePerUnit * items[indexItem].number) - (originalDiscountPerUnit * items[indexItem].number)
          }
        }
      }
    },
    mergeItems(datas) {
      let res = [];
      for (const data of datas) {
        if (data.items && data.items.length) res = [...data.items, ...res];
      }
      return res;
    },
    deleteItem(items, index) {
      items.splice(index, 1);
    },
    isWht(items) {
      return items.filter(d => d.whtPercent > 0).length > 0;
    },
    totalValueIn(item) {
      let total = 0;
      if (this.form.isVatInclusive) {
        total = (item.originalPricePerUnit - this.originalDiscountPerUnit(item)) * item.number
      } else {
        total = item.totalOriginalValue + this.totalVatValueIn(item);
      }
      return Helper.round(total);
    },
    totalVatValueIn(item) {
      let vat = 0;
      if (item.sellVatType == 1) {
        if (this.form.isVatInclusive) {
          vat = (this.totalValueIn(item) * this.$globalVatPercent) / (100 + this.$globalVatPercent) || 0;
        } else {
          vat = ((item.totalOriginalValue * this.$globalVatPercent) / 100) || 0;
        }
      }
      return Helper.round(vat);
    },
    totalNonVatValueIn(item) {
      return Helper.round(this.totalValueIn(item) - this.totalVatValueIn(item));
    },
    totalWhtValueIn(item) {
      if (item.whtPercent > 0) {
        return Helper.round(
          this.totalNonVatValueIn(item) * (item.whtPercent / 100)
        );
      } else {
        return 0;
      }
    },
    totalOriginalValue(items) {
      return Helper.round(
        items.reduce((a, b) => a + (b.totalOriginalValue || 0), 0)
      );
    },
    totalVatValue(items) {
      return Helper.round(
        items.reduce((a, b) => a + (this.totalVatValueIn(b) || 0), 0)
      );
    },
    totalValue(items) {
      return Helper.round(
        items.reduce((a, b) => a + (this.totalValueIn(b) || 0), 0)
      );
    },
    totalNonVatValue(items) {
      return Helper.round(
        items.reduce((a, b) => a + (this.totalNonVatValueIn(b) || 0), 0)
      );
    },
    totalVatItemsValue(items) {
      return Helper.round(
        items
          .filter(d => {
            return d.sellVatType == 1;
          })
          .reduce((a, b) => a + (this.totalNonVatValueIn(b) || 0), 0)
      );
    },
    totalNonVatItemsValue(items) {
      return Helper.round(
        items
          .filter(d => {
            return d.sellVatType != 1;
          })
          .reduce((a, b) => a + (this.totalNonVatValueIn(b) || 0), 0)
      );
    },
    totalWhtValue(items) {
      return Helper.round(
        items.reduce((a, b) => a + (this.totalWhtValueIn(b) || 0), 0)
      );
    },
    originalDiscountPerUnit(item) {
      let originalDiscountPerUnit = 0
      if (item.discountType == 1) {
        originalDiscountPerUnit = item.discountPerUnit || 0
      } else {
        originalDiscountPerUnit = (item.originalPricePerUnit * (item.discountPerUnit || 0) / 100)
      }
      return originalDiscountPerUnit
    },
    discountValue(item) {
      if (this.form.isVatInclusive) {
        return Helper.round(this.originalDiscountPerUnit(item) * item.number)
      } else {
        return Helper.round((this.originalDiscountPerUnit(item) * item.number) + this.discountVatValue(item))
      }
    },
    discountVatValue(item) {
      let vat = 0
      if (item.sellVatType == 1 && item.type == "discount") {
        if (this.form.isVatInclusive) {
          vat = (this.discountValue(item) * this.$globalVatPercent) / (100 + this.$globalVatPercent) || 0
        } else {
          vat = (this.originalDiscountPerUnit(item) * this.$globalVatPercent / 100) * item.number || 0
        }
      }
      return Helper.round(vat)
    },
    totalDiscountValue(items) {
      return Helper.round(
        items.reduce((a, b) => a + (this.discountValue(b) || 0), 0)
      )
    },
    checkExpired(date) {
      let isExpired = false;
      if (date && date.iso) {
        isExpired = this.$moment().isAfter(this.$moment(date.iso));
      } else if (date) {
        isExpired = this.$moment().isAfter(this.$moment(date));
      }
      return isExpired;
    },
    suspendDateFormat(suspend, format = "D MMMM YYYY") {
      let text = "";
      if (suspend.isSuspend) {
        let startDate =
          suspend.startDate && suspend.startDate.iso
            ? suspend.startDate.iso
            : suspend.startDate;
        let endDate =
          suspend.endDate && suspend.endDate.iso
            ? suspend.endDate.iso
            : suspend.endDate;
        text = `${this.$moment(startDate).format(format)} ${this.$t('to')} ${this.$moment(
          endDate
        ).format(format)} (${this.diffDaysIso(suspend)} ${this.$t('day')})`;
      } else {
        text = "-";
      }
      return text;
    },
    async clickLatestBooking(booking) {
      if (booking) {
        //Check booking retry
        this.isLoadReBooking = true
        this.reBookingRes = {
          isShow: false,
          warning: [],
          error: []
        }
        this.form.data = []
        this.form.businessName = booking.businessName
        this.form.bookingChannel = booking.bookingChannel
        if (booking.type == 'monthly') this.form.stallType = booking.stallType
        if (booking.subType) this.form.subType = booking.subType
        else this.form.subType = booking.type
        this.changeSubType(this.form.subType)
        this.form.note = booking.note
        this.form.selectedAreas = []
        this.latestBooking = booking
        let startDate, endDate;
        if (booking.areaBookings) {
          let maxDate;
          let minDate;
          for (let areaBooking of booking.areaBookings) {
            if (!maxDate || maxDate.isBefore(this.$moment(areaBooking.endDate.iso))) {
              maxDate = this.$moment(areaBooking.endDate.iso)
            }
            if (!minDate || minDate.isAfter(this.$moment(areaBooking.startDate.iso))) {
              minDate = this.$moment(areaBooking.startDate.iso)
            }
            for (let product of areaBooking.products) {
              if (!this.form.products.find(d => d.objectId == product.titleId)) {
                this.form.products.push(product)
              }
            }
          }
          let diffDays = this.diffDays({
            startDate: minDate.format("YYYY-MM-DD"),
            endDate: maxDate.format("YYYY-MM-DD"),
            startTime: minDate.format("HH:mm"),
            endTime: maxDate.format("HH:mm")
          })

          startDate = this.$moment()
          if (minDate > startDate) {
            startDate = minDate
            this.form.startDate = startDate.format("YYYY-MM-DD")
            this.form.startTime = startDate.format("HH:mm")
          }
          this.form.endDate = this.$moment(startDate).add(diffDays - 1, 'days').format("YYYY-MM-DD")
          this.form.endTime = maxDate.format("HH:mm")
          
          let formatTime = "YYYY-MM-DD HH:mm";
          startDate = this.$moment(`${this.form.startDate} ${this.form.startTime}`,formatTime)
          endDate = this.$moment(`${this.form.endDate} ${this.form.endTime}`,formatTime)

          if (this.form.subType == "daily-repeat") {
            this.form.loopType = booking.loopType
            this.form.loopDate = booking.loopDate
            this.form.loopWeekDays = booking.loopWeekDays
            this.form.selectedAreas.push(booking.areaBookings[0].area)
          } else {
            await this.searchAllAvailableAreas()
            for (let areaBooking of booking.areaBookings) {
              let area = this.currentVacancyAreas.find(d => d.objectId == areaBooking.area.objectId)
              if (area) {
                this.form.selectedAreas.push(area)
                if (area && (area.statusBooking.color == 'error' || area.statusBooking.color == 'info')) {
                  this.reBookingRes.isShow = true
                  this.reBookingRes.warning.push(area)
                }
              } else {
                this.reBookingRes.isShow = true
                if (this.currentType.isDaily) {
                  areaBooking.area.repeatBookingStatus = `${this.$t('market.market_title')} ${areaBooking.area.name} ${this.$t('area.not_available_in_date')} ${startDate.format("DD MMM YYYY" + `${this.$t('time')}` + "HH:mm" + `${this.$t('timeunit.minute.short')}`)} - ${endDate.format("DD MMM YYYY" + `${this.$t('time')}` + "HH:mm" + `${this.$t('timeunit.minute.short')}`)}`
                } else {
                  areaBooking.area.repeatBookingStatus =  `${this.$t('market.market_title')} ${areaBooking.area.name} ${this.$t('area.not_available_in_date')} ${startDate.format("DD MMM YYYY")} - ${endDate.format("DD MMM YYYY")}`
                }
                this.reBookingRes.error.push(areaBooking.area)
              }
            }
          }
          this.isLoadReBooking = false
          if (this.reBookingRes && this.reBookingRes.isShow) {
            this.repeatBookingStatusDialog = true
          }
        }
        // delay of input form
        setTimeout(() => {
          this.nextStep(1)
          if (this.form.subType == "daily-repeat") this.$refs.selectLoopDate.calLoopData()
        },200)
      }
    },
    dayMonthYearText(startDate, endDate) {
      let days = 0;
      let months = 0;
      let years = 0;
      let text = "";
      if (startDate && endDate) {
        let a = this.$moment(endDate, 'YYYY-MM-DD').endOf("day");
        let b = this.$moment(startDate, 'YYYY-MM-DD').startOf("day");
        a.add(1, "days");
        years = a.diff(b, "year");
        b.add(years, "years");
        months = a.diff(b, "months");
        b.add(months, "months");
        days = a.diff(b, "days");
      }
      if (years) {
        text += `${years} ${this.$t('year')} `;
      }
      if (months) {
        text += `${months} ${this.$t('month')} `;
      }
      if (days) {
        text += `${days} ${this.$t('day')}`;
      }
      return text;
    },
    changeFilterAreas(event, index, refName) {
      if (index >= 0 && this.$refs[`${refName}`]?.[index]?.$children?.[0]) {
        setTimeout(() => {
          this.$refs[`${refName}`][index].$children[0].isMenuActive = true
          this.$refs[`${refName}`][index].$children[0].isFocused = true;
        }, 10)
      } else if (index == -1 && this.$refs[`${refName}`]?.$children?.[0]) {
        setTimeout(() => {
          this.$refs[`${refName}`].$children[0].isMenuActive = true
          this.$refs[`${refName}`].$children[0].isFocused = true;
        }, 10)
      }
    },
    isDuplicateItem(item, items = []) {
      if (item.accountingProduct) {
        return items
          .filter(d =>
            d.accountingProduct?.objectId == item.accountingProduct?.objectId &&
            d.area?.objectId == item.area?.objectId &&
            d.dailyBillingSetting?.objectId == item.dailyBillingSetting?.objectId
          )
          .length > 1
      }
    },
    async searchAllAvailableAreas() {
      this.isLoadSearch = true
      if (this.form.subType == "daily-repeat") {
        await this.$store.dispatch("markets/getMarketArea", {
          id: this.marketId
        });
      } else {
        let formatTime = "YYYY-MM-DD HH:mm";
        this.allAvailableAreas = []
        this.form.tempStartDate = JSON.parse(JSON.stringify(this.form.startDate))
        this.form.tempEndDate = JSON.parse(JSON.stringify(this.form.endDate))
        this.form.tempStartTime = JSON.parse(JSON.stringify(this.form.startTime))
        this.form.tempEndTime = JSON.parse(JSON.stringify(this.form.endTime))
        this.calContractDays()
        this.unAvailableAreas = []
        this.allAvailableAreas = await this.getAvailableAreas({
          marketId: this.marketId,
          startDate: this.$moment(
            `${this.form.startDate} ${this.form.startTime}`,
            formatTime
          ).toDate(),
          endDate: this.$moment(
            `${this.form.endDate} ${this.form.endTime}`,
            formatTime
          ).toDate(),
          areaBookingIds: this.isEdit ? this.booking.areaBookings.map(d => d.objectId) : [],
          contractId: this.form.contract ? this.form.contract.objectId : "",
          type: this.currentType.isDaily ? 'daily' : 'monthly'
        });
        if (this.isEdit) {
          for (let selectedArea of this.form.selectedAreas) {
            if (!this.allAvailableAreas.find(d => d.objectId == selectedArea.objectId)) {
              this.unAvailableAreas.push(selectedArea)
            }
          }
        }
      }
      this.isLoadSearch = false
    },
    editContractDays(value, index) {
      let dataArea = this.form;
      let days = parseFloat(value);
      if (days && days > -1) {
        days--;
        let momentStartDate = this.$moment(dataArea.startDate, "YYYY-MM-DD");
        momentStartDate.add(days, "days");
        dataArea.endDate = momentStartDate.format("YYYY-MM-DD");
      }
    },
    async changeSubType(subType) {
      this.filterArea = "All"
      this.form.loopType = null
      this.formAreaBookings = []
      this.form.loopDays = []
      this.loopData = {
        all: []
      }
      if (subType == "daily" || subType == "daily-repeat") {
        this.form.type = "daily";
        this.form.startDate = this.$moment().format("YYYY-MM-DD");
        this.form.endDate = this.$moment().format("YYYY-MM-DD");
      } else {
        this.form.type = "monthly";
        this.form.startDate = this.$moment().format("YYYY-MM-DD");
        this.form.endDate = this.$moment().add(1, "months").format("YYYY-MM-DD");
        this.form.startTime = "08:00";
        this.form.endTime = "20:00";
        this.calContractDays()
      }
      if (!this.isEdit) this.loadBookingByCustomerLimit()
      await this.searchAllAvailableAreas()
      if (this.form.subType == "daily-repeat") {
        this.form.selectedAreas = this.form.selectedAreas[0] ? [this.form.selectedAreas[0]] : []
      } else {
        for (let [index, area] of this.form.selectedAreas.entries()) {
          if (!this.currentVacancyAreas.find(d => d.objectId == area.objectId)) {
            this.form.selectedAreas.splice(index, 1)
          }
        }
      }
    },
    confirmRemoveAreaBooking(index) {
      this.tempIndex = index
      this.isRemoveAreaBookingDialog = true
    },
    removeAreaBooking(index){
      let date = this.formAreaBookings[index].startDate
      let area = this.formAreaBookings[index].area
      if (this.$refs.selectLoopDate) this.$refs.selectLoopDate.removeLoopData(date)
      this.formAreaBookings.splice(index, 1)
      if (!this.formAreaBookings.find(d => d.area.objectId == area.objectId)) {
        this.form.selectedAreas.splice(index, 1)
      }
      this.isRemoveAreaBookingDialog = false
    },
    nextStep(step) {
      if(step == 1) {
        this.submitStep1()
      } else if(step == 2) {
        this.submitStep2()
      } else if(step == 3) {
        this.submitStep3()
      } 
    },
    submitStep1(){
      if (this.$refs.formStep1.validate()) {
        this.step = 2
      }
    },
    async submitStep2() {
      if (this.isEdit) {
        this.step = 3
      } else {
        if (this.$refs.formStep2.validate()) {
          if (this.form.selectedAreas.length == 0) {
            this.$toast.show({
              content: this.$t('validate.please_select_area'),
              color: "error"
            });
            return false
          }
          this.formAreaBookings = []
          if (this.currentType.isMonthly) {
            for(let area of this.form.selectedAreas) {
              this.formAreaBookings.push({
                startDate: this.form.tempStartDate,
                endDate: this.form.tempEndDate,
                products: this.form.products,
                area: area,
                isExpand: false
              })
            }
            this.step = 3
          } else {
            if (this.form.subType == "daily") {
              for(let area of this.form.selectedAreas) {
                this.formAreaBookings.push({
                  startDate: this.form.tempStartDate,
                  endDate: this.form.tempEndDate, 
                  startTime: this.form.tempStartTime,
                  endTime: this.form.tempEndTime,
                  products: this.form.products,
                  area: area,
                  isExpand: false,
                  invoice: {
                    items: []
                  }
                })
              }
              await this.initBillingSettings(this.formAreaBookings)

              if (this.latestBooking && this.latestBooking.areaBookings) {
                for (let formAreaBooking of this.formAreaBookings) {
                  let areaBooking = this.latestBooking.areaBookings.find(d => d.area.objectId == formAreaBooking.area.objectId)
                  if (areaBooking && areaBooking.products && areaBooking.products.length) {
                    formAreaBooking.products = areaBooking.products
                  }
                  if (areaBooking && this.latestBooking.invoices.find(d => d.areaBooking?.objectId == areaBooking.objectId)) {
                    let invoice  = this.latestBooking.invoices.find(d => d.areaBooking?.objectId == areaBooking.objectId)
                    formAreaBooking.invoice.items = []
                    for (const item of invoice.items) {
                      let accountingProduct = item.accountingProduct;
                      formAreaBooking.invoice.items.push({
                        area: undefined,
                        unit: accountingProduct.unit,
                        sellVatType: accountingProduct.sellVatType,
                        accountingProduct: accountingProduct,
                        accountingProductId: accountingProduct.objectId,
                        whtPercent: this.form.customer && this.form.customer.type == "company" && !this.market.disableWht ? item.whtPercent || 0 : 0,
                        type: accountingProduct.type,
                        originalPricePerUnit: item.originalPricePerUnit,
                        number: item.quantity,
                        totalOriginalValue: item.totalValue,
                        dailyBillingSetting: item.dailyBillingSetting,
                        discountType: item.discountType,
                        discountPerUnit: item.discountPerUnit,
                        type: item.type
                      })
                    }
                  }
                }
              }

              this.step = 3
            } else if (this.form.subType == "daily-repeat") {
              if (this.loopData.all.length == 0) {
                this.$toast.show({
                  content: this.$t('booking.please_select_date_to_booking'),
                  color: "error"
                });
                return false
              }
  
              this.isLoadReBooking = true
              this.eventAvailableAreas = {
                all: [],
                months: {},
              }
              let area = this.form.selectedAreas[0]
              let all = this.loopData.all
  
              this.loadReBookingProgress = 0
              let indexDate = 0
              for (let date of all) {
                let startDate = this.$moment(`${date},${this.form.startTime}`, 'YYYY-MM-DD,HH:mm')
                let endDate = this.$moment(`${date},${this.form.endTime}`, 'YYYY-MM-DD,HH:mm')
  
                const areaAvailable = await this.getAvailableArea({
                  marketId: this.marketId,
                  areaId: area.objectId,
                  startDate,
                  endDate,
                  type: "daily"
                });
  
                let obj = {
                  area,
                  date: date,
                  startTime: this.form.startTime,
                  endTime: this.form.endTime
                }
                if(areaAvailable){
                  obj.isAvailable = true
                  if (areaAvailable.contract){
                    obj.color = "info"
                  } else {
                    obj.color = "success"
                  }
                } else {
                  obj.isAvailable = false
                  obj.color = "error"
                }
                this.eventAvailableAreas.all.push(obj)
  
                indexDate++
                this.loadReBookingProgress = Math.ceil(100 * indexDate / all.length)
              }
              for(let event of this.eventAvailableAreas.all) {
                let mm = this.$moment(event.date)
                if (!this.eventAvailableAreas.months[mm.format("YYYY-MM")]) this.eventAvailableAreas.months[mm.format("YYYY-MM")] = []
                this.eventAvailableAreas.months[mm.format("YYYY-MM")].push(event)
  
                if (!this.eventAvailableAreas.startDate || mm < this.$moment(this.eventAvailableAreas.startDate)){
                  this.eventAvailableAreas.startDate = event.date
                }
  
                if (!this.eventAvailableAreas.endDate || mm > this.$moment(this.eventAvailableAreas.endDate)){
                  this.eventAvailableAreas.endDate = event.date
                }
              }
              this.isLoadReBooking = false
              this.isPreviewRepeatDialog = true
            }
          }
        }
      }
    },
    async initBillingSettings(formAreaBookings) {
      if (!this.form.id) {
        this.isLoadBillingSettings = true
        this.billingSettings = []
        this.billingSettings = await this.getBillingSettingsByAreasFn(formAreaBookings.map(d => d.area.objectId))
        for(let formAreaBooking of formAreaBookings) {
          this.inputSelectArea(formAreaBooking, this.billingSettings)
        }
        this.isLoadBillingSettings = false
      }
    },
    async onConfirmRepeatBooking() {
      for (let data of this.eventAvailableAreas.all) {
        if (data.isAvailable) {
          this.formAreaBookings.push({
            startDate: data.date,
            endDate: data.date, 
            startTime: data.startTime,
            endTime: data.endTime,
            products: this.form.products,
            area: data.area,
            isExpand: false,
            invoice: {
              items: []
            }
          })
        } else {
          this.$refs.selectLoopDate.removeLoopData(data.date)
        }
      }
      await this.initBillingSettings(this.formAreaBookings)
      this.isPreviewRepeatDialog = false
      this.step = 3
    },
    submitStep3() {
      for (let formAreaBooking of this.formAreaBookings) {
        formAreaBooking.isExpand = false
      }
      if (this.formAreaBookings.length == 0) {
        this.$toast.show({
          content: this.$t('validate.please_select_area'),
          color: "error"
        });
        this.step = 2
        return false
      } else if (this.isDuplicateItemData && this.currentType.isDaily) {
        for (let formAreaBooking of this.formAreaBookings) {
          for (let item of formAreaBooking.invoice.items) {
            if (this.isDuplicateItem(item, formAreaBooking.invoice.items)) {
              formAreaBooking.isExpand = true
            }
          }
        }
        this.$toast.show({
          content: this.$t('booking.booking_repeat'),
          color: "error"
        });
      } else {
        this.step = 4
      }
    },
    async changeAddItemAll(isAddItemAll){
      if (isAddItemAll) {
        let tempItems = []
        for (let formAreaBooking of this.formAreaBookings) {
          let items = formAreaBooking.invoice?.items.filter(d => !d.dailyBillingSetting)
          for (let item of items) {
            let tempItem = tempItems.find(d => d.accountingProduct.objectId == item.accountingProduct.objectId && !d.dailyBillingSetting)
            if (!tempItem) tempItems.push(item)
          }
          formAreaBooking.invoice.items = []
        }
        this.inputSelectArea(this.formAreaBookings[0], this.billingSettings)
        for (let item of this.formAreaBookings[0].invoice.items) {
          let areaSize = item?.dailyBillingSetting?.area?.size ? item.dailyBillingSetting.area.size : 0
          if (item.billingSettingType == 'daily') {
            item.number = this.formAreaBookings.length
          } else if (item.billingSettingType == 'booking') {
            item.number = 1
          } else if (item.billingSettingType == 'daily_square_metre') {
            item.number = areaSize * this.formAreaBookings.length
          } else if (item.billingSettingType == 'booking_square_metre') {
            item.number = areaSize
          } 
        }
        for (let tempItem of tempItems) {
          this.formAreaBookings[0].invoice.items.push(tempItem)
        }
        for (let [index, item] of this.formAreaBookings[0].invoice.items.entries()) {
          this.changeTotalOriginalValue(0, index, this.formAreaBookings[0].invoice.items, true)
        } 
      } else {
        let tempItems = this.formAreaBookings[0]?.invoice?.items.filter(d => !d.dailyBillingSetting)
        for (let formAreaBooking of this.formAreaBookings) {
          formAreaBooking.invoice.items = []
          this.inputSelectArea(formAreaBooking, this.billingSettings)
          for (let tempItem of tempItems) {
            formAreaBooking.invoice.items.push(tempItem)
          }
        }
      }
    },
  }
};
</script>

<style lang="scss" scoped>
.customer-box {
  min-height: 128px;
  width: 100%;
  font-weight: bold;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  margin-bottom: 20;

  div {
    color: gray;
  }
}

.box-payment {
  padding: 15px;
}

.booking-box,
.booking-box-non {
  border: 1px solid rgba(128, 128, 128, 0.2);
  padding: 10px 15px;
  margin: 10px 0;
  align-items: center;
}

.booking-box:hover {
  background: rgba(128, 128, 128, 0.05);
  cursor: pointer;
}

.text-areas {
  font-weight: bold;
  font-size: 18px;
}

.summary-topic {
  margin: 5px 0;
  font-weight: 400;
  font-size: 16px;

  &.bold {
    font-weight: 600;
    color: var(--v-success-base);
  }
}

.summary-number {
  margin: 5px 0;
  font-weight: 500;
  font-size: 16px;

  &.bold {
    color: var(--v-success-base);
    font-weight: 700;
  }
}

.repeat-booking {
  padding: 15px !important;
  background: rgba(194, 194, 194, 0.26);

  .repeat-error {
    .repeat-error-header {
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 20px;
      padding-bottom: 10px;
      font-weight: bold;
      color: var(--v-error-base);

      i {
        margin-left: 10px;
      }
    }

    .v-chip {
      white-space: normal;
      padding: 12px;
      height: unset;

      i {
        font-size: 25px;
        margin: 0 10px;
      }
    }
  }

  .repeat-warning {
    margin-top: 15px;

    .repeat-warning-header {
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 20px;
      padding-bottom: 10px;
      font-weight: bold;
      color: var(--v-warning-base);

      i {
        margin-left: 10px;
      }
    }

    .v-chip {
      white-space: normal;
      padding: 12px;
      height: unset;

      i {
        font-size: 25px;
        margin: 0 10px;
      }
    }

  }
}

.date-time-box {
  display: flex;
  flex-wrap: wrap;
  min-width: 250px;
  align-items: center;
  margin: 15px 0;

  .header-in {
    min-width: 150px;
    font-size: 18px;

    .filter {
      text-align: right;
    }
  }

  .header-in.filter {
    display: flex;
    flex-wrap: wrap;
    max-width: 150px;
    justify-content: flex-end;

    * {
      margin: 0 5px;
    }

    .v-chip {
      margin: 0;
    }
  }

  * {
    margin: 0 10px;
  }

  &:first-child {
    margin-top: 40px;
  }

  .v-chip.product {
    margin: 2px 4px;
  }
}

.date-time-box.filter {
  margin-bottom: 0;
}

.date-time-box.filter-b {
  margin-top: 0;
}

.select-all-box {
  // width: 160px;
  display: flex;
  flex-wrap: wrap;
  flex-basis: min-content;

  .v-chip {
    min-width: 160px;
    margin: 5px 2px;
  }
}

.date-time-week-box {
  display: flex;
  flex-wrap: wrap;
  width: min-content;
  align-items: center;
  margin: 0;


  .v-chip-group::v-deep .v-slide-group__content {
    flex-wrap: wrap;
    width: 756px;
  }

  .v-chip-group {
    .v-chip {
      justify-content: center;
      width: 100px;
      margin: 2px 4px;

      div {
        margin: 0;
      }
    }
  }
}

.date-time-week-box.filter {
  // .icon-left {
  //   position: absolute;
  //   top: 0;
  //   left: 0;
  // }
  margin-bottom: 0;
  border-bottom: 1px solid rgb(227, 227, 227);
}

.vertical-top {
  vertical-align: top !important;
}
.daily-color {
  color: var(--daily-booking-base) !important;
}
.monthly-color {
  color: var(--monthly-booking-base) !important;
}

.box-booking-area {
  padding: 10px 25px;
  margin-bottom: 2px;
  box-shadow: 5px 0px 20px rgba(0, 0, 0, 0.1);
  &.monthly {
    &.expand {
      margin-bottom: 30px;
      margin-top: 30px;
      border: 2px solid rgba(var(--monthly-booking), 0.3);
      border-radius: 10px;
      box-shadow: 0px 0px 20px rgba(var(--monthly-booking), 0.3);;
      &.first {
        margin-top: 0;
      }
    }
  }
  &.daily {
    &.expand {
      margin-bottom: 30px;
      margin-top: 30px;
      border: 2px solid rgba(var(--daily-booking), 0.3);
      border-radius: 10px;
      box-shadow: 0px 0px 20px rgba(var(--daily-booking), 0.3);
      &.first {
        margin-top: 0;
      }
    }
  }
}

.box-currency-select {  
  max-width: 300px;
  white-space: nowrap;
  margin-left: auto;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  .txt-title{
    font-size: 14px;
    font-weight: 700;
    color: #666666;
    margin-right: 50px;
  }

  .icon-currency{
    border-radius: 50%;
    margin-top: 3px;
  }

  .icon-currency-avatar{
    height: 20px !important;
    min-width: 20px !important;
    width: 20px !important;
    margin-right: 5px !important;
  }
}

</style>